import { cs, en } from 'vuetify/locale'

export const customCs = {
    ...cs,
    information: ' ',

    // General
    dialog_close: "Zavřít",
    dialog_trash: "Zahodit",
    dialog_save: "Uložit",
    dialog_try_again: "Zkusit znovu",
    action_edit: "Upravit",
    action_add: "Přidat",
    action_create: "Vytvořit",
    action_test: "Otestovat",
    action_copy: "Zkopírovat",
    action_remove: "Odebrat",
    action_delete: "Odstranit",
    action_import: "Importovat",
    action_cancel: "Zrušit",
    action_choose: "Vybrat",
    action_change: "Změnit",
    action_search: "Hledat",
    action_generate: "Vygenerovat",
    action_reset: "Resetovat",
    irreversible_action: "Tato akce je nevratná.",
    role_teacher: "Učitel",
    role_student: "Student",

    // Vuetify
    badge: "Odznak",
    open: "Otevřít",
    close: "Zavřít",
    input: {
        clear: "Vyčistit",
        prependAction: "Akce",
    },

    // LoadingScreen
    error: "Chyba: {0}",
    error_network_connection: "Nejste připojeni k síti",
    error_bad_request: "Neplatný požadavek",
    error_bad_response: "Server je dočasně nedostupný",
    error_concurrent_edit: "Došlo k úpravě jiným uživatelem. Uložte si úpravy bokem a obnovte stránku.",
    error_deleting_lesson: "Chyba při odstraňování lekce",
    error_deleting_week: "Chyba při odstraňování týdne",
    error_deleting_topic: "Chyba při odstraňování tématu",

    // TooltipEmojiSpan
    tooltip_lesson_timed: "Včasné vyřešení do {0}",
    tooltip_lesson_locked: "Obsahuje zamknuté úlohy",
    tooltip_lesson_hidden: "Skryto před studenty",
    tooltip_module_allowed_show: "Povoleno zveřejnění",
    tooltip_module_completed: "Vyřešeno {0}",
    tooltip_module_completed_early: "Vyřešeno včas",
    tooltip_module_requested_help: "Požádáno o pomoc",
    tooltip_module_submitted: "Odesláno k ohodnocení",
    tooltip_module_solved: "Vyřešeno",
    tooltip_module_in_progress: "Rozpracováno",
    tooltip_module_opened: "Otevřeno",
    tooltip_module_unopened: "Neotevřeno",

    // SemesterList
    semester_title: "Semestr",
    semester_list: "Seznam semestrů",
    create_semester: "Vytvořit semestr",
    subjects: "Předměty",
    courses_total: "Celkem kurzů",
    semester_code: "Kód semestru",
    semester_start: "Začátek semestru",
    semester_end: "Konec semestru",
    semester_edit: "Editovat semestr",
    semester_delete: "Odstranit semestr",
    semester_delete_question: "Opravdu si přejete odstranit semestr",
    semester_date_required: "Je potřeba zadat datum",
    semester_cant_delete_courses_present: "Semestr obsahuje aspoň jeden kurz a proto ho nelze odstranit",
    semester_creation_title: "Vytvoření semestru",
    semester_creation_success_text: "Semestr úspěšně vytvořen",
    semester_edit_title: "Editace semestru",
    semester_edit_success_text: "Semestr úspěšně editován",
    semester_deletion_title: "Odstranění semestru",
    semester_deletion_success_text: "Semestr úspěšně odstraněn",

    // Guide
    guides: "Návody",
    guide_list: "Seznam návodů",
    chapters: "Kapitoly",
    chapter_list:"Seznam kapitol",
    guide_not_found: "Návod nebyl nalezen",


    // UserMenu
    user_menu_admin_button: "Správce",
    user_menu_sandbox_button: "Pískoviště",
    user_menu_guarantor_button: "Garant",
    user_menu_teacher_button: "Učitel",
    user_menu_anonymous_mode: "Anonymní režim",
    user_menu_dark_mode: "Tmavý režim",
    user_menu_switch_language: "Use english",
    user_menu_switch_account: "Přepnout účet",
    user_menu_logout: "Odhlásit se",
    user_menu_gitlab_token: "GitLab Token",
    user_menu_update_token: "Aktualizovat Gitlab Token",
    user_menu_update_token_success: "Token byl úspěšně aktualizován",

  // Scanf
  scanf_format_string: "Formátovací řetězec",
  scanf_scan: "Spustit",
  scanf_input_text: "Vstupní text",
  scanf_format_string_explanation: "Vysvětlení formátovacího řetězce",
  scanf_scan_result: "Výsledek",
  scanf_return_value: "Návratová hodnota (počet úspěšně přiřazených hodnot):",
  scanf_value: "Hodnota",
  scanf_expected_argument_type: "Očekávaný typ argumentu",
  scanf_explain_integer: "očekává celé číslo (s volitelným znaménkem). Přeskakuje všechny počáteční bílé znaky.",
  scanf_integer_not_found: "Očekávané celé číslo nebylo nalezeno.",
  scanf_explain_length_modifier_character: "Length modifier",
  scanf_used_length_modifier: "Použitý length modifier",
  scanf_available_length_modifiers: "Dostupné length modifiery pro tento specifier",
  scanf_error: "Chyba",
  scanf_literal_text_first_part: "Doslovný text",
  scanf_literal_text_second_part: "se musí přesně shodovat se vstupem.",
  scanf_explain_whitespace: "<strong>Bílé znaky</strong> – konzumují bílé znaky, dokud nenarazí na znak, který není bílý znak",
  scanf_explain_float: "očekává číslo s plovoucí desetinnou čárkou. Přeskakuje všechny počáteční bílé znaky.",
  scanf_explain_character: "očekává jeden znak. Může číst bílé znaky.",
  scanf_explain_characters_first_part: "očekává",
  scanf_explain_characters_second_part: "znak(ů). Může číst bílé znaky. MŮŽE ZPŮSOBIT BUFFER OVERFLOW, pokud délka načtené sekvence přesáhne kapacitu pole.",
  scanf_explain_string: "očekává řetězec (sekvenci znaků, které nejsou bílými znaky). Připojí znak \\0 na konec načtené hodnoty. Přeskakuje všechny počáteční bílé znaky. MŮŽE ZPŮSOBIT BUFFER OVERFLOW, pokud délka načtené sekvence přesáhne kapacitu pole.",
  scanf_suppress_character: "Potlačující znak '*' – načtená hodnota se neukládá",
  scanf_field_width_first_part: "Šířka",
  scanf_field_width_second_part: "nejvýše tolik znaků se přečte.",
  scanf_integer_error: "Očekávané celé číslo nebylo nalezeno",
  scanf_hex_integer_error: "Očekávané hexadecimální celé číslo nebylo nalezeno",
  scanf_octal_integer_error: "Očekávané osmičkové celé číslo nebylo nalezeno",
  scanf_invalid_length_modifier_for_integer: "Neplatný length modifier pro celé číslo",
  scanf_invalid_length_modifier_for_float: "Neplatný length modifier pro číslo s plovoucí desetinnou čárkou",
  scanf_invalid_length_modifier_for_characters: "Neplatný length modifier pro znaky",
  scanf_invalid_length_modifier_for_string: "Neplatný length modifier pro řetězec",
  scanf_invalid_length_modifier_for_pointer: "Neplatný length modifier pro pointer",
  scanf_unknown_specifier: "Neznámý specifier",
  scanf_unknown_specifier_explanation: "je neznámý specifier",
  scanf_percent: "<strong>%%</strong> – ve formátovacím řetězci očekává %",
  scanf_percent_error: "% neodpovídá.",
  scanf_literal_text_error: "Doslovný text neodpovídá.",
  scanf_string_error: "Očekávaný řetězec nenalezen.",
  scanf_float_error: "Očekávané plovoucí číslo nebylo nalezeno.",
  scanf_character_error: "Očekávaný znak nebyl nalezen",
  scanf_characters_error: "Očekávané znaky nebyly nalezeny",
  scanf_again: "Další",
  scanf_refresh: "Obnovit/Upravit",
  scanf_pointer_error: "Očekávaný ukazatel nebyl nalezený",
  scanf_explain_pointer: "očekává hexadecimální kladné celé číslo a ukládá ho jako pointer. Přeskakuje všechny počáteční bílé znaky.",
  scanf_explain_n: "vrací počet dosud přečtených znaků. Žádný vstup se nekonzumuje. Nezvyšuje počet přiřazení. Pokud má specifikátor definovaný operátor '*', chování je nedefinované.",
  scanf_scanset_missing_bracket: "%[ - chybí uzavírací závorka ]",
  scanf_explain_set: "Načte neprázdnou sekvenci znaků ze sady znaků.<br/>" +
      "Pokud je prvním znakem sady ^, pak jsou načteny všechny znaky, které v sadě nejsou.<br/>" +
      "Pokud sada začíná ] nebo ^], pak je znak ] také zahrnut do sady znaků.<br/>" +
      "Je definováno implementací, zda znak - na jiné než počáteční pozici v sadě může označovat rozsah, jako v [0-9].<br/>" +
      "Na konec načtené sekvence vždy uloží \\0 (takže pole, do kterého čteme musí mít místo pro alespoň šířka+1 znaků).<br/>" +
      "MŮŽE ZPŮSOBIT BUFFER OVERFLOW, pokud délka načtené sekvence přesáhne kapacitu pole."
  ,
  scanf_set_error: "Žádné shodující se znaky nebyly nalezeny",

    // testUsers
    test_users_menu: "Testovací uživatelé",
    test_users_menu_switch_back: "Skutočný účet",
    test_users_title: "Zoznam testovacích užívatelů",
    test_users_create_new: "Nový testovací uživatel",
    test_users_name_input: "Jméno",
    test_users_close: "ZAVŘÍT",
    test_users_create: "VYTVORIŤ",
    test_users_connect: "PREPNÚŤ",
    test_users_swap_back: "PREPNUTIE DO NAOZAJSTNÉHO ÚČTU",
    test_users_name_input_error: "Neplatné meno",
    test_users_create_success: "Testovací uživatel úspešne vtvořen",
    test_users_delete_success: "Testovací uživatel úspešne zmazán",

  //Float
  float_text: "Float",
  double_text: "Double",

  //TopicList
  topic_list_title: "Témata",
  topic_list_empty: "Nejsou dostupná žádná témata",
  topic_list_create: "Vytvořit nové téma",
  topic_list_modules: "{0} modulů",

    //TopicListDeleteDialog
    topic_list_delete_title: "Odstranit téma",
    topic_list_delete_confirm: "Opravdu chcete odstranit téma",
    topic_list_delete_success_title: "Téma odstraněno",
    topic_list_delete_success_text: "Téma bylo úspěšně odstraněno.",

    //TopicListEditDialog
    topic_edit_dialog_create: "Vytvořit téma",
    topic_edit_dialog_edit: "Upravit téma",
    topic_edit_name: "Název tématu",
    topic_edit_success_title: "Téma upraveno",
    topic_edit_success_text: "Téma bylo úspěšně upraveno.",

    // TopicListEditCreateDialog
    topic_edit_notification_title: "Téma upraveno",
    topic_edit_notification_text: "Téma bylo úspěšně upraveno.",
    topic_create_notification_title: "Téma vytvořeno",
    topic_create_notification_text: "Téma bylo úspěšně vytvořeno.",

    // CourseList
    course_list_title: "Kurzy",
    course_list_current_lessons: "Probíhající lekce",
    course_list_empty: "Nejsi členem žádného kurzu. Požádej cvičícího o zapsání do kurzu.",
    course_join: "Připojit se ke kurzu",
    course_join_short: "Připojit se",
    course_join_code: "Kód",
    course_new_join_code: "Nový kód",
    course_save_join_code: "ULOŽIT",
    course_join_invalid_code: "Neplatný kód (musí být jiný pro každý kurz)",
    course_list_role_teacher: " (Učitel)",
    course_list_role_student: " ",
    course_list_lesson_completed: "{0} / {1} lekcí",
    course_list_lesson_completed_tooltip: "{0} lekcí vyřešeno z {1} řešitelných",
    course_list_semesters: "Kurzy ({0})",
    course_list_all_semesters: "Všechny",

    // CurrentLessonList
    current_lesson_list_title: "Probíhající lekce",
    current_lesson_list_empty: "Aktuálně neprobíhají žádné lekce",

    // CurrentLessonListRow
    active_quiz: "Aktivní kvíz",

    // CourseDetail
    course_detail_left_drawer_course_list: "Přehled kurzů",
    course_detail_header_course_secret: "Kód pro připojení",
    course_detail_header_users: "Uživatelé",
    course_detail_header_new_lesson: "Nová lekce",
    course_detail_no_weeks: "Tento kurz neobsahuje žádné týdny.",
    course_detail_week_lesson_order_change: "Přesunout lekci",
    course_detail_week_lesson_order_changed_title: "Lekce přesunuta",
    course_detail_week_lesson_order_changed_text: "Lekce byla úspěšně přesunuta.",
    course_detail_week_lesson_order_changed_error_title: "Chyba při přesunu lekce",
    course_detail_week_lesson_order_changed_error_text: "Při přesunu lekce nastala chyba: {0}",
    hidden_lesson_count: "Týden obsahuje skryté lekce",
    hidden_module_count: "Lekce obsahuje skryté moduly",

    // CourseDetailDeleteDialog
    course_detail_lesson_delete_title: "Odstranit lekci",
    course_detail_lesson_delete_confirm_p1: "Opravdu si přejete odstranit lekci ",
    course_detail_lesson_delete_confirm_p2: "?\nJejí moduly nebudou odstraněny.",
    course_detail_lesson_delete_success_title: "Lekce odstraněna",
    course_detail_lesson_delete_success_text: "Lekce byla úspěšně odstraněna.",
    course_detail_week_delete_title: "Odstranit týden",
    course_detail_week_delete_confirm_p1: "Opravdu si přejete odstranit týden ",
    course_detail_week_delete_confirm_p2: " a všechny jeho lekce?",
    course_detail_week_delete_success_title: "Týden odstraněn",
    course_detail_week_delete_success_text: "Týden byl úspěšně odstraněn.",

    // CourseDetailCopyDialog
    course_detail_copy_search_courses: "Kurzy",
    course_detail_copy_search_name: "Název",
    course_detail_copy_search_lesson_types: "Typy lekcí",
    course_detail_copy_no_courses: "Jste učitelem pouze v tomto kurzu.",
    course_detail_lesson_copy_title: "Zkopírovat lekci",
    course_detail_lesson_copy_tooltip: "Zkopírovat do kurzu",
    course_detail_lesson_copy_success_title: "Lekce zkopírována",
    course_detail_lesson_copy_success_text: "Lekce byla úspěšně zkopírována.",
    course_detail_lesson_copy_no_matches: "Žádná lekce neodpovídá filtru.",
    course_detail_tool_add_title: "Přidat nástroj",
    course_detail_tool_add_no_matches: "Žádný nástroj neodpovídá filtru.",
    course_detail_week_copy_title: "Zkopírovat týden",
    course_detail_week_copy_tooltip: "Zkopírovat do kurzu",
    course_detail_week_copy_success_title: "Týden zkopírován",
    course_detail_week_copy_success_text: "Týden byl úspěšně zkopírován.",
    course_detail_week_copy_no_matches: "Žádný týden neodpovídá filtru.",

    // CourseDeleteDialog
    course_delete_title: "Odstranit kurz",
    course_delete_confirm: "Opravdu si přejete odstranit kurz",
    course_delete_success_title: "Kurz odstraněn",
    course_delete_success_text: "Kurz byl úspěšně odstraněn.",
    error_deleting_course: "Chyba při odstraňování kurzu",

    // CourseJoinCodeDialog
    course_current_code: "Aktuální kód",
    course_no_code_set: "Tento kurz nemá nastavený žádný kód.",

    //CourseCreateEdit
    course_create_edit_title:"Informace",
    course_create_new:"Nový kurz",
    nav_create_course: "Nový kurz",
    course_create_edit_name:"Název",
    course_create_edit_short_name:"Krátký název",
    course_create_edit_teachers_all:"Všichni cvičící",
    course_create_edit_teachers:"Cvičící",
    course_create_edit_add_teachers:"Přidat cvičící",
    course_create_edit_code:"Heslo pro připojení",
    course_create_edit_public:"Veřejný kurz",
    course_create_edit_no_users:"Žadné uživatele nejsou",

    course_edit_notification_title: "Kurz upraven",
    course_edit_notification_text: "Úpravy provedené v kurzu byly uloženy.",
    course_create_notification_title: "Kurz vytvořen",
    course_create_notification_text: "Kurz byl úspěšně vytvořen.",

    // CourseDetailLessonRow
    course_detail_lesson_row_student_list: "Přehled studentů a modulů",

    // CourseDeleteDialog
    course_delete: "Odstranit kurz",
    course_delete_question: "Opravdu si přejete odstranit kurz",
    course_deletion_title: "Odstranění kurzu",
    course_cant_delete_weeks_present: "Kurz obsahuje aspoň jeden týden a proto ho nelze odstranit",
    course_cant_delete_users_present: "Kurz obsahuje aspoň jednoho uživatele a proto ho nelze odstranit",
    course_deletion_success_text: "Kurz úspěšně odstraněn",

    // LessonDetailLeftDrawer
    lesson_detail_intro_text: "Úvodní text",
    module_title_locked: "Zamknutý modul",

    // ModuleUnlockCard
    module_locked_prompt: "Tento modul je zamknutý. Pro odemknutí zadej kód:",
    module_locked_code: "Kód",
    module_locked_unlock: "Odemknout",
    module_student_locked: "Student tento modul ještě neodemknul",
    module_locked_invalid_code: "Nesprávný kód",
    module_locked_depends: "Tento modul se odemkne až po splnění modulu \"{0}\"",

    // LessonModuleDetail
    lesson_edit_modules_remove: "Odebrat modul",
    lesson_edit_modules_empty: "Žádné moduly",
    lesson_edit_modules_add: "Přidat existující modul",
    lesson_edit_modules_create: "Vytvořit nový modul",
    lesson_edit_modules_read: "Zobrazit nastavení modulu",

    solutions: "Řešení",
    solutions_for_module: "Řešení modulu",
    solutions_by_user: "Řešení od",
    progress_overview: "Přehled postupů",
    module_view: "Zobrazit",
    module_edit: "Upravit",
    module_remove_dialog_text_p1: "Opravdu chcete odebrat modul ",
    module_remove_dialog_text_p2: " z lekce?",
    module_remove_dialog_text_p3: `Budete moci jej kdykoliv vrátit v menu "Přidat existující modul".`,
    module_remove_success_title: "Modul odebrán",
    module_remove_success_text: "Modul byl úspěšně odebrán z lekce.",
    module_remove_failure_title: "Odebírání selhalo",
    module_remove_failure_text: "Při odebírání modulu z lekce nastala chyba: {0}",
    tab_assignment: "ZADÁNÍ",
    tab_showcase: "UKÁZKA",
    tab_rating: "Studentská hodnocení",
    tab_rating_empty: "Žadná hodnocení ještě nejsou",
    rating_btn: "TVOJE HODNOCENÍ",
    tab_preview: "NÁHLED",
    tab_editor: "Editor",
    tab_error: "CHYBA",
    tab_empty_text: "V učitelském módu se textové moduly neukazují.",
    tab_not_allowed_share: "Student nepovolil anonymizované zveřejnění svého řešení.",

    //ModuleRating
    rating_edit_notification_title: "Hodnocení upraveno",
    rating_edit_notification_text: "Úpravy provedené v hodnocení byly uloženy.",
    rating_create_notification_title: "Hodnocení vytvořeno",
    rating_create_notification_text: "Hodnocení bylo úspěšně vytvořeno.",
    rating_edit_dialog_edit: "Vyjádřete svůj názor",

    // Subjects
    subject_list: "Předměty a kurzy",
    subject_list_drawer: "Semestry",
    subject_detail_list: "Předměty",
    subject_course_num: "kurz(ů)",
    subject_new_course_button: "Nový kurz",
    subject_course_short_name: "Paralelka",

    subject_detail_left_drawer_subject_list: "Přehled předmětů",
    //SubjectCreateEdit
    subject_create_edit_title:"Informace",
    subject_create_new:"Nový předmět",
    nav_create_subject: "Nový předmět",
    subject_create_edit_name:"Název",
    subject_create_edit_no_guarantors: "Tento předmět neobsahuje žádné garanty.",
    subject_create_edit_guarantors_all:"Všichni garanti",
    subject_create_edit_guarantors_name:"Jméno",
    subject_create_edit_guarantors_username:"Username",
    subject_create_edit_guarantors:"Garanti",
    subject_create_edit_add_guarantors:"Přidat garanty",
    subject_create_edit_code:"Kod",
    subject_create_edit_no_users:"Žadné uživatele nejsou",

    subject_edit_notification_title: "Předmět upraven",
    subject_edit_notification_text: "Úpravy provedené v předmětu byly uloženy.",
    subject_create_notification_title: "Předmět vytvořen",
    subject_create_notification_text: "Předmět byl úspěšně vytvořen.",

    subject_none:  "V tomto semestru není žádný předmět.",
    subject_delete: "Odstranění předmětu",
    subject_delete_question: "Opravdu si přejete odstranit předmět",
    subject_delete_courses_present: "Předmět obsahuje aspoň jeden kurz a proto ho nelze odstranit",

    // LessonCreateEdit
    unsaved_changes_dialog_title: "Neuložené změny",
    unsaved_changes_dialog_text: "Máte neuložené změny. Chcete je zahodit, nebo uložit?",
    lesson_menu_title_create: "Vytvořit lekci",
    lesson_menu_title_edit: "Upravit lekci",
    lesson_menu_detail: "Detail lekce",
    lesson_edit_name: "Jméno",
    lesson_edit_order: "Pořadí",
    lesson_edit_code: "Kód pro odemknutí",
    lesson_edit_type: "Typ",
    lesson_edit_time_start: "Začátek",
    lesson_edit_time_end: "Konec",
    lesson_edit_reset_time: "Použít výchozí",
    lesson_edit_reset_time_tooltip: "Použít začátek a konec týdne",
    lesson_edit_hidden: "Skrýt před studenty",
    lesson_edit_reference_access: "Referenční řešení přístupná od",

    lesson_edit_tab_information: "Informace",
    lesson_edit_tab_text: "Úvodní text",
    lesson_edit_tab_modules: "Moduly",
    lesson_edit_tab_rules: "Bodovací pravidla",
    nav_rule_user_list: "Uživatele",
    nav_rule_detail_user_list: "Uživatele",
    scoring_rule_name_required: "Je potřeba zadat jmeno",
    scoring_rule_short_name_required: "Je potřeba zadat kratké jmeno",
    scoring_rule_date_required: "Je potřeba zadat datům",
    scoring_rule_points_number: "Musi být číslo",

    scoring_rule_student_list: "Přehled studentů a pravidel",

    lesson_edit_modules_sandbox_not_exist: "Pískoviště neexistuje, požádejte správce nebo garanta, aby vám ho vytvořil.",
    lesson_edit_modules_sandbox_empty: "Žádný týden nebo lekce v pískovišti, kam by bylo možné přidat moduly",
    lesson_edit_modules_sandbox_success: "Modul byl úspěšně přidán do pískoviště",
    lesson_edit_modules_sandbox_title: "Testovani modulu",

  //Bodovací pravidla
  lesson_edit_rules_create: "Vytvořit nové pravidlo",
  lesson_edit_rules_edit: "Upravit",
  lesson_edit_rules_edit_description: "Upravit popis",
  lesson_edit_rules_delete: "Odstranění bodovacího pravidla",
  lesson_edit_rule_delete_text_p1: "Opravdu chcete odstranit bodovací pravidlo ",
  lesson_edit_rule_delete_text_p2: "?",
  lesson_edit_rule_until: "do:",
  lesson_edit_rule_to_complete: "k dokončení:",
  lesson_edit_rule_points: "b.",

    rule_edit_notification_title: "Bodovací pravidlo upraveno",
    rule_edit_notification_text: "Úpravy provedené v bodovací pravidlu byly uloženy.",
    rule_create_notification_title: "Bodovací pravidlo vytvořeno",
    rule_create_notification_text: "Bodovací pravidlo bylo úspěšně vytvořeno.",

    rule_create_title: "Vytvoření bodovacího pravidla",
    rule_edit_title: "Editace bodovacího pravidla",

    rule_create_new:"Nové bodovací pravidlo",
    nav_create_rule: "Nové bodovací pravidlo",
    rule_create_edit_name:"Název",
    rule_create_edit_short_name:"Kratký název",
    rule_create_edit_description:"Popis",
    rule_create_edit_points:"Body",
    rule_create_edit_until:"Čas konce",
    rule_create_edit_to_complete:"Body pro ukončení",

    rule_module_num: "modul(ů)",
    lesson_edit_rules_empty: "Žádné bodovací pravidla",

    rule_create_edit_dialog_create: "Vytvořit bodovací pravidlo",
    rule_create_edit_dialog_edit: "Upravit bodovací pravidlo",

    scoring_rule_list_user: "Přehled studentů",
    lesson_scoring_rule_list: "Bodovací pravidla",
    rule_new_module_button: "Přidat modul",
    rule_edit_modules_remove: "Odebrat z pravidla",

    scoring_rule_modules_empty: "Žádné mmoduly",

    lesson_edit_notification_title: "Lekce upravena",
    lesson_edit_notification_text: "Úpravy provedené v lekci byly uloženy.",
    lesson_create_notification_title: "Lekce vytvořena",
    lesson_create_notification_text: "Lekce byla úspěšně vytvořena.",

    lesson_type_tutorial: "Lekce",
    lesson_type_tutorial_preparation: "Příprava k lekci",
    lesson_type_individual_task: "Samostatná práce",
    lesson_type_supplementary: "Doplňkový materiál",
    lesson_type_frequent_mistakes: "Časté chyby",
    lesson_type_information: "Informace",

    // CourseDetailWeekCreateEdit
    week_edit_notification_title: "Týden upraven",
    week_edit_notification_text: "Úpravy provedené v týdnu byly uloženy.",
    week_create_notification_title: "Týden vytvořen",
    week_create_notification_text: "Týden byl úspěšně vytvořen.",

    week_edit_dialog_create: "Vytvořit týden",
    week_edit_dialog_edit: "Upravit týden",
    week_edit_name: "Jméno",
    week_edit_from: "Začátek",
    week_edit_until: "Konec",
    week_new: "Nový týden",
    week_copy: "Zkopírovat týden",

    // ModuleCreateEdit
    module_menu_title_create: "Vytvořit modul",
    module_menu_title_edit: "Upravit modul",

        module_edit_discussion: "Diskuze",
    module_create_comment_success: "Váš komentář byl úspěšně přídán",
    module_create_comment_title: "Vytvoření komentáře",
    module_comment_input: "Napište svůj názor",
    module_comment_name: "Komentář",
    module_delete_comment_success: "Váš komentář byl úspěšně odstraněn",
    module_create_comment_too_long: "Váš komentář je příliš dlouhý nebo kratký",
    module_delete_comment_title: "Odstranění komentáře",
    module_delete_comment_text: "Opravdu chcete odstranit svůj komentář",
    module_show_more: "UKAŽ VÍCE KOMENTÁŘŮ",
    module_show_less: "UKAŽ MÉNĚ KOMENTÁŘŮ",
    module_update_title: "Úprava komentáře",
    module_update_title_success: "Váš komentář byl úspěšně úpraven!",

    module_edit_name: "Jméno",
    module_edit_type: "Typ",
    module_type_text: "Textový modul",
    module_type_code: "Kódový modul",
    module_type_quiz: "Kvízový modul",
    module_type_assignment: "Assignment modul",
    module_type_selftest: "Samotestový modul",
    module_edit_guide_link: "Zobrazit návod",
    module_edit_depend: "Závislost",
    module_edit_no_depend: "(Žádná závislost)",
    module_edit_author: "Autor",
    module_edit_editors: "Spolueditoři",
    module_edit_editors_all: "Všichni učitelé",
    module_edit_difficulty: "Obtížnost",
    module_edit_not_allowed: "Modul musí mít jméno, typ a předmět",
    module_difficulty_none: "Bez hodnocení obtížnosti",
    module_difficulty_beginner: "Začátečník",
    module_difficulty_easy: "Lehký",
    module_difficulty_medium: "Střední",
    module_difficulty_difficult: "Těžký",
    module_difficulty_extreme: "Expert",
    module_edit_subject: "Předměty",
    module_edit_topic: "Téma",
    module_edit_min_percent: "Minimální počet procent pro splnění úlohy: {0} %",
    module_edit_settings: "Nastavení modulu",
    module_edit_lockable: "Zamykatelný 🔑",
    module_edit_time_limit: "Časový limit ⏱️",
    module_edit_manual_eval: "Manuální vyhodnocení",
    module_edit_hidden: "Skryto před studenty 👻",
    module_edit_completed: "Dokončeno",

    module_edit_tab_information: "Informace",
    module_edit_tab_assignment: "Zadání",

    module_edit_notification_title: "Modul upraven",
    module_edit_notification_text: "Úpravy provedené v modulu byly uloženy.",
    module_create_notification_title: "Modul vytvořen",
    module_create_notification_text: "Modul byl úspěšně vytvořen.",

    // ModuleList
    module_list_add_title: "Přidání modulu",
    module_list_header_id: "Identifikátor",
    module_list_header_name: "Název",
    module_list_header_author: "Autor",
    module_list_header_type: "Typ",
    module_list_header_topics: "Témata",
    module_list_header_subjects: "Předměty",
    module_list_header_isCompleted: "Stav",
    module_list_completed: "Dokončeno",
    module_list_not_completed: "Nedokončeno",
    module_list_header_authors_selected: "Vybráno {0}",
    module_list_header_topics_selected: "Vybráno {0}",
    module_list_header_subjects_selected: "Vybráno {0}",
    module_list_header_action: "Akce",
    module_list_empty: "Žádné moduly k přidání",
    module_list_search_empty: "Žádné moduly neodpovídají vašemu vyhledávání",
    module_list_topics_empty: "Žádná témata",
    module_list_subjects_empty: "Žádné předměty",
    module_list_clear_filters: "Vymazat filtry",
    module_list_delete_module_title: "Odstranit modul",
    module_list_delete_module_text_p1: "Opravdu chcete odstranit modul ",
    module_list_delete_module_text_p2: "?",
    module_list_cannot_delete: "Modul může být odstraněn pouze autorem",
    module_list_cannot_add: "Tento modul již je součástí této lekce",

    // CourseUserList
    course_user_delete_dialog_title : "Odebrat uživatele",
    course_user_delete_dialog_text: "Opravdu chcete odebrat uživatele&nbsp;<strong>{0}</strong>&nbsp;z kurzu?",
    course_user_delete_success_title: "Odebrání úspěšné",
    course_user_delete_success_text: "Uživatel byl úspěšně odebrán z kurzu.",
    course_user_delete_error_title: "Chyba při odstraňování",
    course_user_delete_error_text: "Při odebírání uživatele z kurzu došlo k chybě: {0}.\nOdebírat uživatele z kurzu může pouze garant předmětu.",

    course_secret_change_title: "Změnit kód",
    course_secret_changed_title: "Kód změněn",
    course_secret_changed_text: "Kód pro připojení ke kurzu byl úspěšně změněn.",

    course_users: "Uživatelé",
    course_import_users: "Import uživatelů",

  course_user_table_name: "Jméno",
  course_user_table_username: "Username",
  course_user_table_role: "Role",
  course_user_table_progress: "Postup",
  course_user_table_action: "Akce",
  course_user_remove: "Odebrat z kurzu",
  course_user_impersonation: "Impersonovat",
  course_user_detail_link: "Detail uživatele",
  course_user_list_left_drawer_users: "Přehled uživatelů",

    // CourseUserImport
    course_user_import_title: "Import uživatelů",
    course_user_import_label: "Zkopírujte z KOSu / Progtestu seznam uživatelů a vložte je zde ve formátu: name;username;role",
    course_user_imported_title: "Import úspěšný",
    course_user_imported_text: "Uživatelé byli úspěšně přidáni do kurzu.",

    // LessonUserList
    lesson_user_list_title: "Přehled studentů",
    lesson_user_list_header_user: "Uživatel",
    lesson_user_list_header_solution: "Řešení modulu",
    lesson_user_list_header_detail: "Detail",
    lesson_user_list_filter_completed: "Ukázat úspěšná řešení",
    lesson_user_list_filter_requests: "Ukázat žádosti",
    lesson_user_list_filter_allowed_show: "Ukázat pouze zveřejněná řešení",
    lesson_user_list_row_detail: "Řešení uživatele",

  // LessonUserListLeftDrawer
  lesson_user_list_left_drawer_users: "Přehled řešení",
  lesson_user_list_left_drawer_module: "Detail modulu",
  lesson_user_list_empty: "Zadaný filtr nesplňuje žádný uživatel",
  lesson_user_list_previous: "Předchozí",
  lesson_user_list_next: "Další",
  lesson_user_list_rule: "Bodovací pravidla",

  // LessonSolutions
  lesson_solutions_users: "Studenti",
  lesson_solutions_modules: "Moduly",
  lesson_solutions_to_lesson: "Zpět do lekce",
  lesson_solutions_course_users: "Uživatelé v kurzu",
  lesson_solutions_note_visible_lesson: "Poznámka: Jsou vypsáni pouze studenti, kteří mohou danou lekci zobrazit.",
  lesson_solutions_delete_dialog_start_answer: "Opravdu si přejete odstranit tuto odpověď?",
  lesson_solutions_delete_dialog_start_comment: "Opravdu si přejete odstranit tento komentář?",

  // NotificationMenu`
  notification_menu_title: "Notifikace",
  notification_show_satisfied: "Pouze vyřešené",
  notification_hide_satisfied: "Schovat vyřešené",
  notification_list_empty: "✨ Nemáte žádné nepřečtené notifikace",
  notification_list_all_empty: "✨ Nemáte žádné notifikace",
  notification_list_mark_satisfied: "Označit vše jako přečtené",
  notification_list_show_all: "Všechny notifikace",

  notification_help:
      "😸 {0} odpověděl na tvou žádost o pomoc u úlohy <strong>{1}</strong>: {2}",
  notification_comment:
      "💬 {0} okomentoval tvé řešení úlohy <strong>{1}</strong>: {2}",
  notification_evaluate:
      "⬇️ {0} ohodnotil tvé řešení úlohy <strong>{1}</strong>: {2}",
  notification_help_teacher:
      "😿 {0} požádal o pomoc u úlohy <strong>{1}</strong>: {2}",
  notification_evaluate_teacher:
      "⬆️ {0} požádal o ohodnocení úlohy <strong>{1}</strong>: {2}",
  notification_comment_teacher:
      "💬 {0} bylo okomentováno jeho řešení úlohy <strong>{1}</strong>: {2}",

  // AppFooter
  trainer_footer_title: "Trainer – podpora výuky",
  trainer_footer_report: "Nahlásit problém",
  trainer_version: "Verze",

  // Nav
  nav_users: "Uživatelé",
  nav_import_users: "Import uživatelů",
  nav_create_lesson: "Nová lekce",
  nav_edit_lesson: "Úprava",
  nav_lesson_solutions: "Řešení",
  nav_lesson_user_list: "Uživatelé",
  nav_create_module: "Nový modul",
  nav_notification_list: "Všechny notifikace",

  // Separate pages
  presentation_page_title: "Prezentace",
  info_page_title: "Informace",
  guide_page_title: "Příručka",
  guide_teachers: "Návod pro učitele",
  guide_students: "Návod pro studenty",
  guide_guarantors: "Návod pro garanty",
  guide_admins: "Návod pro správce",

  // LoginForm
  login: "Přihlásit se",
  login_ctu: "Přihlášení ČVUT účtem",
  presentation_link: "Prezentace",
  show_info: "O aplikaci",

  // Requests
  pending_request_eval: "Žádost o ohodnocení",
  pending_request_help: "Žádost o pomoc",
  pending_request_eval_teacher: "Nezodpovězená žádost o ohodnocení: {0}",
  pending_request_help_teacher: "Nezodpovězená žádost o pomoc: {0}",

  right_drawer_requests: "Žádosti",
  right_drawer_compilation: "Kompilace a testy",

  request_none: "Žádné žádosti.",
  request_eval_btn: "Odevzdat",
  request_eval_cancel_btn: "Zrušit odevzdání",
  request_help_btn: "Požádat o pomoc",
  request_help_cancel_btn: "Zrušit žádost",
  request_load_fail: "Chyba při načítání žádostí",
  request_load_text_fail: "Při načítání žádostí došlo k chybě: {0}",
  request_no_text: "<bez textu>",
  request_teacher_eval_btn: "Ohodnotit",
  request_teacher_comment_btn: "Okomentovat",
  request_teacher_help_btn: "Odpovědět",
  request_teacher_answered: "{0} odpověděl",
  request_teacher_commented: "{0} okomentoval",
  request_answer_delete_btn: "Odstranit odpověď",
  request_comment_delete_btn: "Odstranit komentář",
  request_answer_deleted_title: "Odpověď odstraněna",
  request_answer_deleted_title_fail: "Chyba při odstraňování odpovědi",
  request_answer_deleted_text: "Odpověď byla úspěšně odstraněna.",
  request_answer_deleted_text_fail: "Při pokusu o odstranění odpovědi došlo k chybě: {0}",

  edit_code_from_gitlab: "Importovat z Gitlabu",
  gitlab_import_list_header_name: "Jméno Projektu",
  gitlab_import_list_URI: "Odkaz na projekt v GitLabu",
  gitlab_import_list_URI_btn: "Přejít",
  gitlab_update_btn: "Aktualizovat z Gitlabu",
  gitlab_delete_btn: "Smazat spojení z Gitlabem",
  gitlab_change_btn: "Změnit soubor z Gitlabu",
  gitlab_pipeline_generate_btn: "Vygenerovat pipeline",
  gitlab_pipeline_generate_dialog_title: "Vygenerovaná pipeline",
  gitlab_pipeline_copy_clipboard: "Kopírovat do schránky",
  gitlab_pipeline_copy_clipboard_notification_title: "Kopírovaní do schránky",
  gitlab_pipeline_copy_clipboard_notification_text:
      "Úspěšně zkopírováno do schránky",
  gitlab_dialog_title: "Importování z Gitlabu",
  import_gitlab_list_list_header_type: "Vlastní project",
  import_gitlab_list_list_header_type_true: "Jenom vlastní",
  import_gitlab_list_list_header_type_false: "Všechny projekty",
  import_gitlab_list_list_header_search: "Hledat",
  gitlab_import_list_header_description: "Popis",
  gitlab_import_list_header_check_files: "Soubory na importování",
  gitlab_import_list_header_check_files_folder: "Soubory v dece",
  gitlab_import_list_import_btn: "Importovat soubor",
  gitlab_return_back_folder: "Předchozí deka",
  gitlab_import_page_back: "Předchozí stránka",
  gitlab_import_page_front: "Další stránka",
  gitlab_back: "Zpatky do Listu Projektu",

  gitlab_error_projects: "Došlo k chybě. Zkontrolujte prosím, zda je token Gitlabu správný.",
  gitlab_error_change_link: "Nový import má jiný typ modulu.",
  gitlab_error_student_module: "Nesprávný typ souboru.",

  gitlab_was_imported_dialog_header: "Tento soubor již byl importován",
  gitlab_was_imported_dialog_body:
      "Chcete tento soubor znovu importovat? Nebo chcete zkopírovat existující modul?",
  gitlab_was_imported_dialog_body_description:
      "Kopirování modulu znamená, že bude vytvořen nový modul bez spojení z Gitlabem. Importování znovu vytvoří nový modul, který bude spojení se stejným souborem jako existujicí modul. ",
  gitlab_was_imported_dialog_import_btn: "Importovat",
  gitlab_import_loading_screen: "Probíhá importování",
  gitlab_was_imported_dialog_copy_btn: "Kopirovat modul",
  gitlab_was_imported_dialog_cancel_btn: "Zpatky",

  gitlab_import_file_list_header_name: "Jméno souboru",
  gitlab_import_file_list_header_path: "Cesta ke souboru",
  gitlab_import_file_list_header_add_file_as: "Importovat kongifuraci",

  import_gitlab_import_dialog_notification: "Import z Gitlabu",
  import_gitlab_import_dialog_notification_success:
      "Soubor byl úspěšně importován!",
  import_gitlab_import_dialog_notification_error:
      "Soubor nelze impotovat!",
  import_gitlab_import_dialog_notification_cancel: "Import byl zastaven.",
  import_gitlab_import_dialog_notification_copy_success:
      "Modul byl úspěšně zkopírován!",

  import_gitlab_file_list_type_description: "Zadání modulu",
  import_gitlab_file_list_type_default_code: "Kód modulu",
  import_gitlab_file_list_type_test_code: "Test kód modulu",
  import_gitlab_file_list_type_config: "Konfigurace",
  import_gitlab_file_list_add_to_module: "Importovat Soubor",
  import_gitlab_file_branch: "Větev",

  //Logs
  log_button: "Logy",
  log_list: "Seznam logů",
  log_delete: "Odstranit logy",
  log_delete_older_than: "Odstranit logy starší než",
  log_date_required: "Je potřeba zadat datum",
  log_delete_title: "Odstranění logů",
  log_delete_success_text: "Logy byly uspěšně odstraněny",


    //Import paralelek
    view_students: "Zobrazit studenty",
    import_students: "Importovat studenty z CSV",
    import_students_from_csv: "Import studentů z CSV",
    select_student_csv: "Vyberte CSV soubor studentů",
    upload_and_preview: "Nahrát a zobrazit náhled",
    select_parallels_to_create: "Vyberte paralelky, které chcete vytvořit",
    select_all: "Vybrat vše",
    parallel: "Paralelka",
    student_count: "Studenti",
    actions: "Akce",
    create_selected_parallels: "Vytvořit vybrané paralelky",
    selected: "Vybráno",
    start_over: "Začít znovu",
    first_name: "Jméno",
    last_name: "Příjmení",
    username: "Uživatelské jméno",
    ungrouped: "Bez skupiny",
    csv_only_error: "Podporovány jsou pouze soubory .csv.",
    csv_empty_error: "CSV soubor je prázdný nebo neplatný.",
    csv_no_students_error: "V CSV souboru nebyli nalezeni žádní validní studenti.",
    csv_parse_failed: "Nepodařilo se načíst soubor",
    csv_course_create_notification_title: "Kurzy vytvořeny",
    csv_course_create_notification_text: "Vybrané paralelky byly úspěšně vytvořeny",
    failed_for: "selhalo pro",
    btn_subject_create_new: "Vytvořit nový předmět",
    missing_semester_or_subject: "Chybí id semestru nebo předmětu",
    set_ids: "Nastavit ids",
    semester_id: "ID semestru",
    subject_id: "ID předmětu",
    import_id_cancel: "Zrušit",
    import_id_save: "Uložit",

    request_help: {
        title: "Žádost odeslána",
        title_fail: "Chyba při odesílání",
        text: "Žádost o pomoc byla úspěšně odeslána.",
        text_fail: "Při pokusu o odeslání žádosti o pomoc došlo k chybě: {0}",

    dialog_title: "Žádost o pomoc",
    textarea: "Text žádosti",
    action: "Odeslat",

    cancel_title: "Žádost zrušena",
    cancel_title_fail: "Chyba při rušení žádosti",
    cancel_text: "Žádost o pomoc byla úspěšně zrušena.",
    cancel_text_fail: "Při rušení žádosti o pomoc došlo k chybě: {0}",
    cancel_text_fail_satisfied: "Žádost o pomoc již byla vyřízena.",
  },
  request_teacher_help: {
    title: "Žádost vyřešena",
    title_fail: "Chyba při odesílání",
    text: "Žádost o pomoc byla úspěšně vyřešena.",
    text_fail: "Při pokusu o vyřešení žádosti o pomoc došlo k chybě: {0}",

    dialog_title: "Odpovědět na žádost o pomoc",
    textarea: "Odpověď",
    action: "Odpovědět",
  },
  request_eval: {
    title: "Úloha odevzdána",
    title_fail: "Chyba při odevzdávání",
    text: "Úloha byla úspěšně odevzdána k ohodnocení učitelem.",
    text_fail: "Při pokusu o odevzdání úlohy došlo k chybě: {0}",

    dialog_title: "Odevzdat úlohu",
    textarea: "Komentář",
    action: "Odevzdat",

    cancel_title: "Žádost zrušena",
    cancel_title_fail: "Chyba při rušení žádosti",
    cancel_text: "Žádost o ohodnocení byla úspěšně zrušena.",
    cancel_text_fail: "Při rušení žádosti o ohodnocení došlo k chybě: {0}",
    cancel_text_fail_satisfied: "Žádost o ohodnocení již byla vyřízena.",
  },
  request_teacher_eval: {
    title: "Úloha ohodnocena",
    title_fail: "Chyba při odesílání",
    text: "Žádost o ohodnocení byla úspěšně vyřešena.",
    text_fail: "Při pokusu o ohodnocení úlohy došlo k chybě: {0}",

    dialog_title: "Ohodnotit úlohu",
    textarea: "Hodnocení",
    percent: "Hodnocení: {0} %",
    action: "Ohodnotit",
    toggle: "Označit úlohu jako vyřešenou",
  },
  request_teacher_comment: {
    title: "Úloha okomentována",
    title_fail: "Chyba při odesílání",
    text: "Úloha byla úspěšně okomentována.",
    text_fail: "Při pokusu o okomentování úlohy došlo k chybě: {0}",

    dialog_title: "Okomentovat úlohu",
    textarea: "Komentář",
    percent: "Hodnocení: {0} %",
    action: "Okomentovat",
    toggle: "Označit úlohu jako vyřešenou",
  },

  // CodeModuleBottomOverlay
  code_module: {
    allowed_show: {
      title: "Zveřejnění úspěšné",
      title_fail: "Zveřejnění neúspěšné",
      text: "Anonymizované zveřejnění kódu bylo úspěšné.",
      text_fail: "Při anonymizovaném zveřejňování kódu došlo k chybě: {0}",
    },
    disallowed_show: {
      title: "Zrušení zveřejnění úspěšné",
      title_fail: "Zrušení zveřejnění neúspěšné",
      text: "Zrušení anonymizovaného zveřejnění kódu bylo úspěšné",
      text_fail:
          "Při rušení anonymizovaného zveřejnění kódu došlo k chybě: {0}",
    },

    allow_show_tooltip: "Povolit anonymizované zveřejnění",
    disallow_show_tooltip: "Zrušit anonymizované zveřejnění",
    file_upload: "Kód (.c, .cpp, .cxx, .h, .hpp, .hxx)",
    code_inserted_title: "Vložení kódu úspěšné",
    code_inserted_text: "Kód byl úspěšně vložen, probíhá testování...",
    code_inserted_failure_title: "Vložení kódu neúspěšné",
    code_inserted_failure_text:
        "Systém nebyl schopen rozpoznat, který soubor se snažíte nahrát.\nNázev nahraného souboru musí končit stejně, jako název souboru v editoru,\nnapř. student.cpp -> cokolivxyz-student.cpp",
    download: "Stáhnout",
    download_archive: "Stáhnout archiv",
    download_archive_error_title: "Stažení archivu selhalo",
    download_archive_error_text: "Požadovaný archiv se nepodařilo vygenerovat nebo stáhnout.",
    default_code: "Výchozí kód",
    submitted_code: "Odevzdaný kód",
    reference_solution: "Referenční řešení",
    test_data: "Testovací data",
    reset_progress: "Resetovat postup",
    reset_progress_dialog_text: "Opravdu chcete resetovat svůj postup v tomto modulu?",
    test_name_tooltip: "Název testovací sady",
    tests_passed_total_tooltip: "Počet splněných testů v sadě",
    tests_show_outputs: "Zobrazit výstupy",
    tests_show_error: "Zobrazit chybu",
    tests_description: "Popis:",
    terminate: "Zastavit",
    run_tests: "Otestovat",run_showcase: "Spustit ukázku",
    tab_input: "Vstup",
    tab_comparison: "Srovnání",
    tab_compilation: "Chyba kompilace",
    tab_student: "Student",
    tab_reference: "Reference",
    test_compilation: "Kompilace",
    test_compilation_info: "Provede kompilaci a slinkování kódu.",
    character_limit: "Znaků: {0} / {1}",
    edit_module: "Upravit modul",
    module_solutions: "Zobrazit řešení modulu",
    tab_teacher: "TESTER",
    code_comment: "Komentář",
    create_code_comment: "Napsat komentář",

    error_compiling: "Chyba při kompilaci",
    error_code_too_large: "Kód je příliš dlouhý ({0} / {1} znaků)",
    error_linking: "Chyba při linkování",
    error_output: "Výstup",
    error_ret_code_not_ok: "Program skončil s nenulovým návratovým kódem {0}",
    error_should_fail_didnt_fail: "Program byl chybný, ale studentovy asserty neodhalily chybu.",
    error_shouldnt_fail_did_fail: "Program byl správný, ale některý ze studentových assertů selhal.",
    error_invalid_output: "Nesprávný výstup",
    error_missing_output_image: "Studentův obrázek nebyl nalezen",
    error_memory_not_freed: "Program uvolnil pouze {0} / {1} bloků dynamicky alokované paměti.",
    error_exception_limit_exceeded: "Program překročil povolený počet použití výjimek. Použil {0} výjimek, limit byl {1}.",
    error_program_timeout: "Studentský program překročil povolenou dobu běhu, {0}.",

    edit_tab_information: "Kódový modul",
    edit_tab_information_tests_success_title: "Úspěch",
    edit_tab_information_tests_success_body: "Testy úspěšně importovány",
    edit_tab_tests: "Testy",
    edit_tab_student: "Výchozí kód",
    edit_tab_envelope: "Obálka kódu",
    edit_tab_teacher: "Testovací kód",

    edit_code_type: "Typ kódu",
    type_showcase: "Ukázka kódu",
    type_test_io: "Standardní I/O test",
    type_test_assert: "Assertový test",
    type_write_assert: "Napiš asserty",

    edit_interaction: "Interakce",
    interaction_editor: "Editor a nahrávání kódu",
    interaction_updown: "Pouze nahrávání kódu",

    code_limit_small: "Malý (1 kB)",
    code_limit_medium: "Střední (5 kB)",
    code_limit_large: "Velký (10 kB)",

    edit_file_limit: "Limit na velikost nahraného souboru",
    file_limit_small: "Malý (10 kB)",
    file_limit_medium: "Střední (40 kB)",
    file_limit_large: "Velký (80 kB)",

    edit_envelope_type: "Obálka kódu",
    env_type_c: "C kód (bez I/O)",
    env_type_c_io: "C kód, přesměrované I/O",
    env_type_cpp: "C++ kód (bez STL)",
    env_type_cpp_stl: "C++ kód (včetně STL)",
    env_type_custom: "Vlastní obálka",

    edit_library: "Knihovna",
    library_type_none: "Žádná",
    library_type_c: "C knihovna",
    library_type_cpp: "C++ knihovna",

    edit_external_library: "Knihovna pro linkování",

    edit_reference_public: "Referenční řešení je stáhnutelné",

    edit_hide_compiler_output:
        "Schovat výstup kompilátoru. Student vidí pouze zda kompilace proběhla neúspěšně.",

    file_label_showcase: "Ukázkové vstupy (.in) v archivu .tar",
    file_label_test_io: "Testovací vstupy (.in, .ref) v archivu .tar",

    edit_test_name: "Název testu",
    edit_test_description: "Popis testu",
    edit_test_parameter: "Parametr (kladné celé číslo)",
    edit_test_parameter_tooltip: "Jeden test odpovídá jednomu spuštění testovacího kódu, s tímto číslem jako argumentem z příkazové řádky.",
    edit_test_time_limit: "Časový limit v celých sekundách (prázdný = bez limitu)",
    edit_test_exception_limit: "Limit použití výjimek (celé číslo) (prázdný = bez limitu)",
    edit_test_check_memory: "Kontrolovat práci s pamětí",
    edit_test_hidden: "Skrýt výsledky testu",
    edit_test_should_fail: "Program má selhat",
    delete_test: "Odstranit test",
    delete_test_dialog_start: "Opravdu si přejete odstranit test ",
    delete_test_dialog_middle: "?",
    create_test: "Přidat test",
    delete_test_title: "Test odstraněn",
    delete_test_text: "Test byl úspěšně odstraněn.",
    new_test: "Nový test",
    create_test_requirements: "Pro vytvoření testu musíš zadat jeho jméno, popis a parametr",

    edit_file_name: "Název souboru",
    edit_file_code_limit: "Limit na velikost nahraného kódu",
    edit_file_content: "Výchozí obsah souboru",
    edit_file_header_file: "Hlavičkový soubor (nekompilovat)",
    edit_file_reference: "Referenční řešení",
    delete_file: "Odstranit soubor",
    delete_file_dialog_start: "Opravdu si přejete odstranit soubor ",
    delete_file_dialog_middle: "?",
    create_file: "Přidat soubor",
    delete_file_title: "Soubor odstraněn",
    delete_file_text: "Soubor byl úspěšně odstraněn.",
    new_file: "Nový soubor",
    create_file_requirements: "Pro vytvoření souboru musíš zadat jeho jméno a obsah",

    // Automatic generation
    generate_dialog_title: "Vygenerovat nastavení",
    generate_dialog_text_p1: "Chcete využít výchozí nastavení (testy, soubory, obálku a testovací kód) pro tento typ kódového modulu?",
    generate_dialog_text_p2: "Pozor: Nevratně vymaže všechna dosavadní nastavení.",
    generate_dialog_no: "Ne",
    generate_dialog_yes: "Ano",

    basic_test_name: "Základní test",
    basic_test_description: "Test základní funkcionality",
    random_test_name: "Náhodný test",
    random_test_description: "Test náhodnými hodnotami",
    efficiency_test_name: "Test efektivity",
    efficiency_test_description: "Testuje efektivitu programu",
    correct_implementation_test_name: "Správná implementace",
    correct_implementation_test_description: "Všechny asserty projdou při správné implementaci testované funkce",
    wrong_implementation_test_name: "Nesprávná implementace",
    wrong_implementation_test_description: "Asserty zachytí nesprávnou implementaci",
  },

  //QuizModule
  quiz_module: {
    create_new_quiz_tab: "Kvízový editor",
    question_list: "Seznam otázek",
    add_existing_question: "Přidat existující otázku",
    create_new_question: "přidat novou otázku",
    create_new_quiz_heading: "Tvorba kvízu",
    question: "Otázka",
    new_question_dialog_heading: "Nová otázka",
    edit_question_dialog_heading: "Úprava otázky",
    chosen_question_type: "Vybraný typ otázky",
    tooltip_truefalse:
        "Položte otázku resp. výrok a vyberte zda je pravdivý nebo ne",
    tooltip_multichoice:
        "Položte otázku a následně zadejte studentům možnosti ze kterých budou moci vybírat",
    option: "Možnost",
    correct_option: "Správne?",
    add_option: "Přidat možnost",
    time_limit: "Časový limit (sekundy)",
    explanation: "Vysvětlení",

    question_list_add_title: "Přidat otazku",
    question_list_header_id: "Identifikátor",
    question_list_header_text: "Text otazky",
    question_list_header_author: "Autor",
    question_list_header_type: "Typ",
    question_list_header_topics: "Témata",
    question_list_header_subjects: "Předměty",
    question_list_header_topics_selected: "Vybráno {0}",
    question_list_header_subjects_selected: "Vybráno {0}",
    question_list_header_action: "Akce",
    question_list_empty: "Žádné otazky k přidání",
    question_list_search_empty: "Žádné otazky neodpovídají vašemu vyhledávání",
    question_list_topics_empty: "Žádná témata",
    question_list_subjects_empty: "Žádné předměty",
    question_list_clear_filters: "Vymazat filtry",

    question_list_delete_question_title: "Odstranit otázku",
    question_list_delete_question_text_p1: "Opravdu chcete odstranit otázku ",
    question_list_delete_question_text_p2: "?",
    question_list_cannot_delete: "Otázka může být odstraněna pouze autorem",
    question_list_cannot_add: "Tato otázka již je součástí tohoto kvízu",

    remove_question: "Odebrat otázku",
    remove_question_dialog_start: "Opravdu chcete odebrat tuto otázku z kvízu?",
    remove_question_dialog_end: `Budete moci ji kdykoliv vrátit v menu "Přidat existující otázku".`,

    create_question: "Vytvořit otázku",
    edit_question: "Upravit otázku",

    quiz: "Kvíz",
    no_questions_dialog_heading: "Tento kvíz neobsahuje žádné otázky",
    no_questions_dialog_text:
        "Před spuštěním kvízu do něj dejte alespoň jednu otázku",
    create_room: "Vytvořit místnost",
    enter_room: "Vstoupit",
    wrong_code_dialog: "Špatný kód",
    wrong_code_dialog_text:
        "Zkontroluj kód a zkus znovu. Popřípadě zkontroluj, zda zadáváš kód od správného kvízu, pokud jich máte v lekci více.",
    enter_code_placeholder: "Zadej kód - (cvičící ho pravděpodobně promítá)",

    waiting_room: "Čekárna",
    waiting_room_joke: "Rychle si projdi, co ses měl na toto cvičení naučit",
    room_password: "Heslo",
    number_of_students: "Počet studentů: ",
    students: "Studenti",
    launch_quiz: "Spustit kvíz",

    next_question: "Další otázka",
    end_quiz: "Ukončit kvíz",

    results: "Výsledky",
    review: "Náhled",
    leave: "Odejít",

    points: "Body",
    student_passed: "Prošel",
    student_didnt_pass: "Neprošel",

    fix_eval: "Opravit hodnocení",
    reasign_points: "Přepočítat body",
    go_back: "Zpět",
    question_edited_allert_heading: "Otázka upravena",
    question_edited_allert_text: "Bodové hodnocení upraveno u studentů:",
    room_id: "ID místnosti",
  },

  //SelftesModule
  selftest_module: {
    create_new_selftest_tab: "Selftestový editor",
    selftest_heading_info:
        "Zde můžete vložit otázky, ze kterých si studenti budou moci generovat testy na procičování.",

    selftest: "Samotest",
    number_of_questions: "Počet otázek",
    too_many_questions: "Príliš veľa otázok",
    invalid_number_of_questions: "Neplatný počet otázok",
    time_difficulty: "Časová náročnost",
    launch: "Spustit",
    to_review: "Náhled",
    leave: "Ukončit",
    question: "Otázka",
    question_status_positive: "Vyplnená",
    question_status_negative: "Nevyplnená",
    to_question: "K otázke",
    hand_in: "Odovzdať",
    correctly_answered: "Správne zodpovedaných",
    success_rate: "Úspešnosť",
    to_start: "K hlavnej obrazovke",

    attempt: "Pokus",
    quizroom: "Miestnosť",
  },

  // AssignmentModule
  assignment_module: {
    error_file_too_large: "Soubor je příliš velký (max. velikost je 1 MB)",
    input_label: "Obrázek (.jpg, .jpeg, .png)",
  },

  // Template
  template_title: "Šablona",
  template_module_test_title: "Použít šablonu",
  template_module_test_button: "Zkopírovat testy z jiného modulu",
  template_create_button: "Vytvořit šablonu",
  template_use_button: "Použít šablonu",
  template_create_notification_title: "Šablona vytvořena",
  template_create_notification_text:
      "Šablona byla úspěšně vytvořena.",
  template_update_notification_title: "Šablona upravena",
  template_update_notification_text:
      "Šablona byla úspěšně upravena",
  template_list_delete_template_title: "Odstranit šablonu",
  template_list_delete_template_text_p1: "Opravdu chcete odstranit šablonu ",

  //Dev version notofication
  dev_version_notofication: "Pozor! Toto je DEV verze aplikaci.",

  //Impersonation
  impersonation_mode: "Jsi v režimu impersonace",
  impersonation_mode_off: "Ukončit režim impersonace",
  impersonation_mode_out: "Impersonace ukončena",
  impersonation_activated_title: "Impersonace aktivována",
  impersonation_activated_text_prefix: "Nyní se díváš jako",
  impersonation_error_title: "Chyba impersonace",
  impersonation_error_fallback: "Impersonace selhala.",
  error_creating_user: "Chyba při vytvoření uživatele",
  error_deleting_user: "Chyba při smazání uživatele",
  create_test_user_title: "Vytvořit testovacího uživatele",
  name_placeholder: "Franta Omáčka",
  test_users_list_title: "Seznam testovacích uživatelů",
  create_test_user_btn: "Vytvořit testovacího uživatele",
  connect_btn: "připojit se",
  confirm_delete_test_user: "Vážně si přejete odstranit testovacího uživatele",
  no_test_users_found: "Nebyli nalezeni žádní tetsovací uživatelé.",
  // Custom compiler flags
  custom_compiler_flag_title: "Vlastní compiler flags",
  custom_compiler_flag_close: "Zavřít",
  custom_compiler_flag_name: "Název (volitelné)",
  custom_compiler_flag_flags: "Flags",
  custom_compiler_flag_action: "Akce",
  custom_compiler_flag_name_placeholder: "Zadejte název",
  custom_compiler_flag_flags_placeholder: "Zadejte vlastní -D flags, např. -DITER=1000 -DMAX_TIME=10",
  custom_compiler_flag_success: "ÚSPĚCH",
  custom_compiler_flag_error: "CHYBA",
  custom_compiler_flag_create_success: "Flag byl úspěšně přidán",
  custom_compiler_flag_edit_success: "Flag byl úspěšně upraven",
  custom_compiler_flag_delete_success: "Flag byl úspěšně odstraněn",
  custom_compiler_flag_invalid_flag: "Zadaný flag není platný",
  custom_compiler_flag_add_new_title: "Vytvoriť nový flag",

  // Test groups
  test_group_title: "Testovací skupiny",
  test_group_name: "Skupina",
  test_group_unassigned_tests: "Nepřiřazené testy",
  test_group_unassigned_tests_placeholder: "Přetáhněte testy ze skupin sem pro jejich odřazení",
  test_group_placeholder: "Přetáhněte testy sem",
  test_group_description_placeholder: "Žádný compiler flag",
  test_group_test_move_success: "Test byl úspěšně přesunut",
  test_group_test_assign_success: "Test byl úspěšně přiřazen",
  test_group_test_unassign_success: "Test byl úspěšně odřazen",
  test_group_delete_success: "Testovací skupina byla úspěšně smazána",
  test_group_no_groups_placeholder: "Nemáte žádné testovací skupiny",
  test_group_edit_name_title: "Název testovací skupiny",
  test_group_edit_flag_title: "Vlastní flagy",
  test_group_edit_create_button: "VYTVOŘIT",
  test_group_edit_selection_name: "Název",
  test_group_edit_go_back: "Zpět",
  test_group_edit_create_success: "Testovací skupina byla úspěšně vytvořena",
  test_group_edit_create_fail: "Vytvoření testovací skupiny se nezdařilo",
  test_group_edit_success: "Testovací skupina byla úspěšně upravena",
  test_group_edit_fail: "Úprava testovací skupiny se nezdařila",
  test_group_add_new_title: "Přidat novou testovací skupinu",
  test_group_notification_success: "ÚSPĚCH",
}

export const customEn = {
  ...en,
  information: " ",
    // General
    dialog_close: "Cancel",
  dialog_delete: "Delete",
  dialog_trash: "Trash",
  dialog_save: "Save",
  dialog_try_again: "Try again",
  action_edit: "Edit",
  action_add: "Add",
  action_create: "Create",
  action_test: "Test",
  action_copy: "Copy",
  action_remove: "Remove",
  action_delete: "Delete",
  action_import: "Import",
  action_cancel: "Cancel",
  action_choose: "Choose",
  action_change: "Change",
  action_search: "Search",action_generate: "Generate",
  action_reset: "Reset",
  irreversible_action: "This action is irreversible.",
  role_teacher: "Teacher",
  role_student: "Student",

  // Vuetify
  badge: "Badge",
  open: "Open",
  close: "Close",
  input: {
    clear: "Clear",
    prependAction: "Action",
  },

  // LoadingScreen
  error: "Error: {0}",
  error_network_connection: "You're not connected to the network",
  error_bad_request: "Invalid request",
  error_bad_response: "Server is not available at the moment",
  error_concurrent_edit:
      "Another user edited before you did. Save the changes aside and refresh the page.",
  error_deleting_lesson: "Error deleting lesson",
  error_deleting_week: "Error deleting week",
  error_deleting_topic: "Error deleting topic",

  // TooltipEmojiSpan
  tooltip_lesson_timed: "Timed completion until {0}",
  tooltip_lesson_locked: "Contains locked tasks",
  tooltip_lesson_hidden: "Hidden from students",
  tooltip_module_allowed_show: "Allowed to show",
  tooltip_module_completed: "Completed on {0}",
  tooltip_module_completed_early: "Completed early",
  tooltip_module_requested_help: "Help requested",
  tooltip_module_submitted: "Submitted for evaluation",
  tooltip_module_solved: "Solved",
  tooltip_module_in_progress: "In progress",
  tooltip_module_opened: "Opened",
  tooltip_module_unopened: "Not opened",

  // SemesterList
  semester_title: "Semesters",
  semester_list: "Semester list",
  create_semester: "Create semester",
  subjects: "Subjects",
  courses_total: "Course count",
  semester_code: "Semester code",
  semester_start: "Start of the semester",
  semester_end: "End of the semester",
  semester_edit: "Edit semester",
  semester_delete: "Delete semester",
  semester_delete_question: "Are you sure you want to delete semester",
  semester_date_required: "Date is required",
  semester_cant_delete_courses_present:
      "Semester has at least one course so it can't be deleted",
  semester_creation_title: "Semester creation",
  semester_creation_success_text: "Semester created successfully",
  semester_edit_title: "Semester editing",
  semester_edit_success_text: "Semester edited successfully",
  semester_deletion_title: "Semester deletion",
  semester_deletion_success_text: "Semester deleted successfully",

  // Guide
  guides: "Guides",
  guide_list: "Guide list",
  chapters: "Chapters",
  chapter_list: "Chapter list",
  guide_not_found: "Guide not found",

  // Scanf
  scanf_format_string: "Format String",
  scanf_scan: "Scan",
  scanf_input_text: "Input Text",
  scanf_format_string_explanation: "Format String Explanation",
  scanf_scan_result: "Scan Result",
  scanf_return_value: "Return value (number of successfully assigned values):",
  scanf_value: "Value",
  scanf_expected_argument_type: "Expected argument type",
  scanf_explain_integer: "expects an integer (with optional sign). Skips all leading whitespace characters.",
  scanf_explain_hex_integer: "expects a hexadecimal integer (with optional sign). Skips all leading whitespace characters.",
  scanf_explain_octal_integer: "expects an octal integer (with optional sign). Skips all leading whitespace characters.",
  scanf_integer_not_found: "Expected integer not found.",
  scanf_length_modifier_character_explanation: "This is a length modifier for used type specifier.",
  scanf_used_length_modifier: "Used length modifier",
  scanf_available_length_modifiers: "Available length modifiers for this specifier",
  scanf_error: "Error",
  scanf_literal_text_first_part: "Literal text",
  scanf_literal_text_second_part: "must match exactly in the input.",
  scanf_explain_whitespace: "<strong>Whitespace</strong> – consume whitespace characters until non-whitespace character is encountered",
  scanf_explain_float: "expects a floating point number. Skips all leading whitespace characters.",
  scanf_explain_character: "expects a single character. Can read whitespace characters.",
  scanf_explain_characters_first_part: "expects",
  scanf_explain_characters_second_part: "character(s). Can read whitespace characters. MAY CAUSE BUFFER OVERFLOW if the argument array length is lower than the amount of read characters.",
  scanf_explain_string: "expects a string (non-whitespace characters). Appends a \\0 character to the end of the read value. Skips all leading whitespace characters. MAY CAUSE BUFFER OVERFLOW if the argument array length is lower than the amount of read characters..",
  scanf_suppress_character: "Suppress character '*' – the read value is not stored",
  scanf_field_width_first_part: "Width",
  scanf_field_width_second_part: "at most this many characters are read.",
  scanf_integer_error: "Expected integer not found.",
  scanf_hex_integer_error: "Expected hexadecimal integer not found.",
  scanf_octal_integer_error: "Expected octal integer not found.",
  scanf_invalid_length_modifier_for_integer: "Invalid length modifier for integer",
  scanf_invalid_length_modifier_for_float: "Invalid length modifier for float",
  scanf_invalid_length_modifier_for_characters: "Invalid length modifier for characters",
  scanf_invalid_length_modifier_for_string: "Invalid length modifier for string",
  scanf_invalid_length_modifier_for_pointer: "Invalid length modifier for pointer",
  scanf_unknown_specifier: "Unknown specifier",
  scanf_unknown_specifier_explanation: "is an unknown specifier",
  scanf_percent: "<strong>%%</strong> – in the format string will match %",
  scanf_percent_error: "% does not match.",
  scanf_literal_text_error: "Literal text does not match.",
  scanf_string_error: "Expected string not found.",
  scanf_float_error: "Expected float not found",
  scanf_character_error: "Expected character not found.",
  scanf_characters_error: "Expected character(s) not found.",
  scanf_again: "Next",
  scanf_refresh: "Refresh/Edit",
  scanf_pointer_error: "Expected pointer not found",
  scanf_explain_pointer: "expects a hexadecimal positive number and stores it as a pointer. Skips all leading whitespace characters.",
  scanf_explain_n: "returns the number of characters read so far. No input is consumed. Does not increment the assignment count. If the specifier has assignment-suppressing operator defined, the behavior is undefined.",
  scanf_scanset_missing_bracket: "%[ - missing closing bracket ]",
  scanf_explain_set: "Matches a non-empty sequence of characters from set of characters.<br/>" +
      "If the first character of the set is ^, then all characters not in the set are matched.<br/>" +
      "If the set begins with ] or ^] then the ] character is also included into the set.<br/>" +
      "It is implementation-defined whether the character - in the non-initial position in the scanset may be indicating a range, as in [0-9].<br/>" +
      "Always stores \\0 at the end of the matched sequence (so the argument array must have room for at least width+1 characters).<br/>" +
      "MAY CAUSE BUFFER OVERFLOW if the matched sequence length surpasses the argument array capacity."
  ,
  scanf_set_error: "No characters matched",

  //Float
  float_text: "Float",
  double_text: "Double",


  // UserMenu
  user_menu_admin_button: "Admin",
  user_menu_sandbox_button: "Sandbox",
  user_menu_guarantor_button: "Guarantor",
  user_menu_teacher_button: "Teacher",
  user_menu_anonymous_mode: "Anonymous mode",
  user_menu_dark_mode: "Dark mode",
  user_menu_switch_language: "Použít češtinu",
  user_menu_switch_account: "Switch account",
  user_menu_logout: "Logout",
  user_menu_gitlab_token: "GitLab Token",
  user_menu_update_token: "Send new Gitlab Token",
  user_menu_update_token_success: "Token was successfully saved",

    // testUsers
    test_users_menu: "Test users",
    test_users_menu_switch_back: "Switch to real account",
    test_users_title: "Test users list",
    test_users_create_new: "Create test user",
    test_users_name_input: "Name",
    test_users_close: "CLOSE",
    test_users_create: "CREATE",
    test_users_connect: "CONNECT",
    test_users_swap_back: "SWAP BACK TO REAL USER",
    test_users_name_input_error: "Invalid name",
    test_users_create_success: "Test user created successfully",
    test_users_delete_success: "Test user deleted successfully",

    //TopicList
    topic_list_title: "Topics",
    topic_list_empty: "There are no topics yet.",
    topic_list_create: "Create a topic",
    topic_list_modules: "{0} modules",

    //TopicListDeleteDialog
    topic_list_delete_title: "Delete topic",
    topic_list_delete_confirm: "Are you sure you want to delete the topic",
    topic_list_delete_success_title: "Topic deleted",
    topic_list_delete_success_text: "The topic has been successfully deleted.",

    //TopicListEditDialog
    topic_edit_dialog_create: "Create topic",
    topic_edit_dialog_edit: "Edit topic",
    topic_edit_name: "Topic name",
    topic_edit_success_title: "Topic modified",
    topic_edit_success_text: "The topic has been successfully edited.",


    topic_edit_notification_title: "Topic edited",
    topic_edit_notification_text: "Topic has been edited successfully.",
    topic_create_notification_title: "Topic created",
    topic_create_notification_text: "Topic has been created successfully.",


    // CourseList
    course_list_title: "Courses",
    course_list_current_lessons: "Ongoing lessons",
    course_list_empty: "You are not a member of any course. Ask the teacher to add you to a course.",
    course_join: "Join a course",
    course_join_short: "Join",
    course_join_code: "Code",
    course_new_join_code: "New code",
    course_save_join_code: "SAVE",
    course_join_invalid_code: "Invalid code (code must be unique for every course)",
    course_list_role_teacher: " (Teacher)",
    course_list_role_student: " ",
    course_list_lesson_completed: "{0} / {1} lessons",
    course_list_lesson_completed_tooltip: "{0} lessons completed out of {1} completable",
    course_list_semesters: "Courses ({0})",
    course_list_all_semesters: "All",

    // CurrentLessonList
    current_lesson_list_title: "Ongoing lessons",
    current_lesson_list_empty: "No lessons currently ongoing",


    // CurrentLessonListRow
    active_quiz: "Active quiz",

    // CourseDetail
    course_detail_left_drawer_course_list: "Course list",
    course_detail_header_course_secret: "Join code",
    course_detail_header_users: "Users",
    course_detail_header_new_lesson: "New lesson",
    course_detail_no_weeks: "This course has no weeks.",
    course_detail_week_lesson_order_change: "Move lesson",
    course_detail_week_lesson_order_changed_title: "Lesson moved",
    course_detail_week_lesson_order_changed_text: "Lesson has been moved successfully.",
    course_detail_week_lesson_order_changed_error_title: "Error whilst moving lesson",
    course_detail_week_lesson_order_changed_error_text: "An error occurred whilst trying to move lesson: {0}",
    hidden_lesson_count: "Week contains hidden lessons",
    hidden_module_count: "Lesson contains hidden modules",

    // CourseDetailDeleteDialog
    course_detail_lesson_delete_title: "Delete lesson",
    course_detail_lesson_delete_confirm_p1: "Are you sure you want to delete lesson ",
    course_detail_lesson_delete_confirm_p2: "?\nIts modules will not be deleted.",
    course_detail_lesson_delete_success_title: "Lesson deleted",
    course_detail_lesson_delete_success_text: "The lesson has been successfully deleted.",
    course_detail_week_delete_title: "Delete week",
    course_detail_week_delete_confirm_p1: "Are you sure you want to delete week ",
    course_detail_week_delete_confirm_p2: " and all of its lessons?",
    course_detail_week_delete_success_title: "Week deleted",
    course_detail_week_delete_success_text: "The week has been successfully deleted.",

    // CourseDetailCopyDialog
    course_detail_copy_search_courses: "Courses",
    course_detail_copy_search_name: "Name",
    course_detail_copy_search_lesson_types: "Lesson types",
    course_detail_copy_no_courses: "You are not a teacher in any courses other than this one.",
    course_detail_lesson_copy_title: "Copy lesson",
    course_detail_lesson_copy_tooltip: "Copy to course",
    course_detail_lesson_copy_success_title: "Lesson copied",
    course_detail_lesson_copy_success_text: "The lesson has been successfully copied.",
    course_detail_lesson_copy_no_matches: "No lessons correspond to the filter.",
    course_detail_tool_add_title: "Add tool",
    course_detail_tool_add_no_matches: "No tool correspond to the filter.",
    course_detail_week_copy_title: "Copy week",
    course_detail_week_copy_tooltip: "Copy to course",
    course_detail_week_copy_success_title: "Week copied",
    course_detail_week_copy_success_text: "The week has been successfully copied.",
    course_detail_week_copy_no_matches: "No weeks correspond to the filter.",

    // CourseDetailLessonRow
    course_detail_lesson_row_student_list: "Overview of students and modules",

    // CourseDeleteDialog
    course_delete: "Delete course",
    course_delete_question: "Are you sure you want to delete course",
    course_deletion_title: "Course deletion",
    course_deletion_success_text: "Course deleted successfully",
    course_cant_delete_weeks_present: "Course has at least one week so it can't be deleted",
    course_cant_delete_users_present: "Course has at least one users so it can't be deleted",

    // CourseJoinCodeDialog
    course_current_code: "Current code",
    course_no_code_set: "This course has no join code set.",

    // LessonDetailLeftDrawer
    lesson_detail_intro_text: "Introduction",
    module_title_locked: "Locked module",

    // ModuleUnlockCard
    module_locked_prompt: "This module is locked. To unlock, enter the code:",
    module_locked_code: "Code",
    module_locked_unlock: "Unlock",
    module_student_locked: "The student hasn't unlocked this module yet",
    module_locked_invalid_code: "Invalid code",
    module_locked_depends: "This module will unlock upon completion of module \"{0}\"",

    // LessonModuleDetail
    lesson_edit_modules_remove: "Remove module",
    lesson_edit_modules_empty: "No modules",
    lesson_edit_modules_add: "Add existing module",
    lesson_edit_modules_create: "Create new module",
    lesson_edit_modules_read: "View module settings",

    solutions: "Solutions",
    solutions_for_module: "Solutions for module",
    solutions_by_user: "Solutions by",
    progress_overview: "Progress overview",
    module_view: "View",
    module_edit: "Edit",
    module_remove_dialog_text_p1: "Are you sure you want to remove module ",
    module_remove_dialog_text_p2: " from this lesson?",
    module_remove_dialog_text_p3: 'You may add it back at any time in the "Add existing module" menu.',
    module_remove_success_title: "Module removed",
    module_remove_success_text: "The module has successfully been removed from this lesson",
    module_remove_failure_title: "Removal failed",
    module_remove_failure_text: "An error occured while trying to remove the module: {0}",
    tab_assignment: "ASSIGNMENT",
    tab_showcase: "SHOWCASE",
    tab_rating: "Student Ratings",
    tab_rating_empty: "No ratings yet",
    rating_btn: "YOUR RATING",
    tab_preview: "PREVIEW",
    tab_editor: "Editor",
    tab_error: "ERROR",
    tab_empty_text: "Text modules are not shown in teacher mode.",
    tab_not_allowed_share: "Student has not allowed publishing of his solution.",

    //ModuleRating
    rating_edit_notification_title: "Rating edited",
    rating_edit_notification_text: "Rating has been edited successfully.",
    rating_create_notification_title: "Rating created",
    rating_create_notification_text: "Rating has been created successfully.",
    rating_edit_dialog_edit: "Express your opinion",


    // Subjects
    subject_list: "Subjects and courses",
    subject_list_drawer: "Semesters",
    subject_detail_list: "Subjects",
    subject_course_num: "course(s)",
    subject_new_course_button: "New course",
    subject_course_short_name: "Parallel",

    subject_detail_left_drawer_subject_list: "Subject list",

    //SubjectCreateEdit
    subject_create_edit_title:"Information",
    subject_create_new:"New subject",
    nav_create_subject: "New subject",
    subject_create_edit_name:"Name",
    subject_create_edit_no_guarantors: "This subject has no guarantors.",
    subject_create_edit_guarantors_all:"All guarantors",
    subject_create_edit_guarantors_name:"Name",
    subject_create_edit_guarantors_username:"Username",
    subject_create_edit_guarantors:"Guarantors",
    subject_create_edit_add_guarantors:"Add guarantors",
    subject_create_edit_code:"Code",
    subject_create_edit_no_users:"No users",

    subject_edit_notification_title: "Subject edited",
    subject_edit_notification_text: "Changes made in this subject were saved.",
    subject_create_notification_title: "Subject created",
    subject_create_notification_text: "Subject has been created successfully.",

    subject_none: "There is no subjects in this semester.",

    subject_delete: "Delete subject",
    subject_delete_courses_present: "Subject has at least one course so it can't be deleted",
    subject_delete_question: "Are you sure you want to delete subject",

    // LessonCreateEdit
    unsaved_changes_dialog_title: "Unsaved changes",
    unsaved_changes_dialog_text: "You have unsaved changes. Do you want to trash them, or save them?",
    lesson_menu_title_create: "Create lesson",
    lesson_menu_title_edit: "Edit lesson",
    lesson_menu_detail: "Lesson detail",
    lesson_edit_name: "Name",
    lesson_edit_order: "Order",
    lesson_edit_code: "Unlock code",
    lesson_edit_type: "Type",
    lesson_edit_time_start: "Start time",
    lesson_edit_time_end: "End time",
    lesson_edit_reset_time: "Use default",
    lesson_edit_reset_time_tooltip: "Use start and end time of week",
    lesson_edit_hidden: "Hide from students",
    lesson_edit_reference_access: "Reference solutions accessible from",

    lesson_edit_tab_information: "Information",
    lesson_edit_tab_text: "Introduction text",
    lesson_edit_tab_modules: "Modules",
    lesson_edit_tab_rules: "Scoring rules",
    nav_rule_user_list: "Scoring rule users",
    nav_rule_detail_user_list: "Scoring rule users",
    scoring_rule_name_required: "Name is required",
    scoring_rule_short_name_required: "Short name is required",
    scoring_rule_date_required: "Date is required",
    scoring_rule_points_number: "Has to be a number",

    scoring_rule_student_list: "Overview of students and rules",

    lesson_edit_modules_sandbox_not_exist: "Sandbox does not exist, ask admin or guarantor to create one for you",
    lesson_edit_modules_sandbox_empty: "No week or lesson in sandbox to add modules to",
    lesson_edit_modules_sandbox_success: "Module added to sandbox",
    lesson_edit_modules_sandbox_title: "Module testing",

    lesson_edit_rules_create: "Create new rule",
    lesson_edit_rules_edit: "Edit",
    lesson_edit_rules_edit_description: "Edit description",
    lesson_edit_rules_delete: "Delete scoring rule",
    lesson_edit_rule_delete_text_p1: "Are you sure you want to delete scoring rule ",
    lesson_edit_rule_delete_text_p2: "?",
    lesson_edit_rule_until: "until:",
    lesson_edit_rule_to_complete: "to complete:",
    lesson_edit_rule_points: "p.",

    rule_edit_notification_title: "Scoring rule edited",
    rule_edit_notification_text: "Changes made in this scoring rule were saved.",
    rule_create_notification_title: "Scoring rule created",
    rule_create_notification_text: "Scoring rule has been created successfully.",

    rule_create_title: "Scoring rule creation",
    rule_edit_title: "Scoring rule edit",

    rule_create_new:"New scoring rule",
    nav_create_rule: "New scoring rule",
    rule_create_edit_name:"Name",
    rule_create_edit_short_name:"Short name",
    rule_create_edit_description:"Description",
    rule_create_edit_points:"Points",
    rule_create_edit_until:"Time of the end",
    rule_create_edit_to_complete:"Modules to complete",

  rule_module_num: "modul(s)",
  lesson_edit_rules_empty: "No scoring rules",

    rule_create_edit_dialog_create: "Create scoring rule",
    rule_create_edit_dialog_edit: "Edit scoring rule",

    scoring_rule_list_user: "User list",
    lesson_scoring_rule_list: "Scoring rules",
    rule_new_module_button: "Add module",
    rule_edit_modules_remove: "Remove from rule",

    scoring_rule_modules_empty: "No modules",

    lesson_edit_notification_title: "Lesson edited",
    lesson_edit_notification_text: "Changes made in this lesson were saved.",
    lesson_create_notification_title: "Lesson created",
    lesson_create_notification_text: "Lesson has been created successfully.",

    lesson_type_tutorial: "Lesson",
    lesson_type_tutorial_preparation: "Lesson preparation",
    lesson_type_individual_task: "Individual task",
    lesson_type_supplementary: "Supplementary material",
    lesson_type_frequent_mistakes: "Frequent mistakes",
    lesson_type_information: "Information",

    // CourseDetailWeekCreateEdit
    week_edit_notification_title: "Week edited",
    week_edit_notification_text: "Changes made to this week have been saved.",
    week_create_notification_title: "Week created",
    week_create_notification_text: "Week has been created successfully.",

    week_edit_dialog_create: "Create week",
    week_edit_dialog_edit: "Edit week",
    week_edit_name: "Name",
    week_edit_from: "Start",
    week_edit_until: "End",
    week_new: "New week",
    week_copy: "Copy week",

    // ModuleCreateEdit
    module_menu_title_create: "Create module",
    module_menu_title_edit: "Edit module",

    module_edit_discussion: "Discussion",
    module_create_comment_success: "Your comment was successfully added!",
    module_create_comment_title: "Comment creation",
    module_comment_input: "Write your opinion",
    module_comment_name: "Comment",
    module_delete_comment_success: "Your comment was successfully deleted!",
    module_create_comment_too_long: "Your comment is too long or too short",
    module_delete_comment_title: "Delete comment",
    module_delete_comment_text: "Are you sure you want to delete your comment?",
    module_show_more: "SHOW MORE COMMENTS",
    module_show_less: "SHOW LESS COMMENTS",
    module_update_title: "Updating comment",
    module_update_title_success: "Your comment was successfully updated!",

    module_edit_name: "Name",
    module_edit_type: "Type",
    module_type_text: "Text module",
    module_type_code: "Code module",
    module_type_quiz: "Quiz module",
    module_type_assignment: "Assignment module",
    module_type_selftest: "Selftest module",
    module_edit_guide_link: "View guide",
    module_edit_depend: "Dependency",
    module_edit_no_depend: "(No dependency)",
    module_edit_author: "Author",
    module_edit_editors: "Editors",
    module_edit_editors_all: "All teachers",
    module_edit_difficulty: "Difficulty",
    module_edit_not_allowed: "The module must have a name, a type, and a subject",
    module_difficulty_none: "No difficulty rating",
    module_difficulty_beginner: "Beginner",
    module_difficulty_easy: "Easy",
    module_difficulty_medium: "Medium",
    module_difficulty_difficult: "Difficult",
    module_difficulty_extreme: "Expert",
    module_edit_subject: "Subjects",
    module_edit_topic: "Topic",
    module_edit_min_percent: "Minimum percent for completing the task: {0} %",
    module_edit_settings: "Module settings",
    module_edit_lockable: "Lockable",
    module_edit_time_limit: "Time limit",
    module_edit_manual_eval: "Manual evaluation",
    module_edit_hidden: "Hidden from students",
    module_edit_completed: "Completed",

    module_edit_tab_information: "Information",
    module_edit_tab_assignment: "Assignment",

    module_edit_notification_title: "Module edited",
    module_edit_notification_text: "Changes made to the module have been saved.",
    module_create_notification_title: "Module created",
    module_create_notification_text: "Module has been created successfully.",

    // ModuleList
    module_list_add_title: "Add module",
    module_list_header_id: "Identifier",
    module_list_header_name: "Name",
    module_list_header_author: "Author",
    module_list_header_type: "Type",
    module_list_header_topics: "Topics",
    module_list_header_subjects: "Subjects",
    module_list_header_authors_selected: "{0} selected",
    module_list_header_topics_selected: "{0} selected",
    module_list_header_subjects_selected: "{0} selected",
    module_list_header_action: "Action",
    module_list_empty: "No modules to add",
    module_list_search_empty: "No modules correspond to your search",
    module_list_topics_empty: "No topics",
    module_list_subjects_empty: "No subjects",
    module_list_clear_filters: "Clear filters",
    module_list_delete_module_title: "Delete module",
    module_list_delete_module_text_p1: "Are you sure you want to delete module ",
    module_list_delete_module_text_p2: "?",
    module_list_cannot_delete: "Only the author of a module may delete it",
    module_list_cannot_add: "This module is already a part of this lesson",

        // CourseUserList
    course_user_delete_dialog_title : "Remove user",
    course_user_delete_dialog_text: "Are you sure you want to remove user&nbsp;<strong>{0}</strong>&nbsp;from course?",
    course_user_delete_success_title: "Removal successful",
    course_user_delete_success_text: "User has been removed from course successfully.",
    course_user_delete_error_title: "Error whilst removing",
    course_user_delete_error_text: "An error occured whilst trying to remove user from course: {0}.\nOnly a guarantor of the subject may remove users from a course.",

    course_secret_change_title: "Change code",
    course_secret_changed_title: "Code changed",
    course_secret_changed_text: "Join code has been changed successfully.",

    course_users: "Users",
    course_import_users: "Import users",

  course_user_table_name: "Name",
  course_user_table_username: "Username",
  course_user_table_role: "Role",
  course_user_table_progress: "Progress",
  course_user_table_action: "Action",
  course_user_remove: "Remove from course",
  course_user_impersonation: "Impersonate",
  course_user_detail_link: "User detail",
  course_user_list_left_drawer_users: "User list",

    // CourseUserImport
    course_user_import_title: "Import users",
    course_user_import_label: "Copy user list from KOS / Progtest and insert them here in format: name;username;role",
    course_user_imported_title: "Import successful",
    course_user_imported_text: "Users have been imported to the course.",

    course_delete_title: "Delete course",
    course_delete_confirm: "Are you sure you want to delete the course",
    course_delete_success_title: "Course deleted",
    course_delete_success_text: "Course was successfully deleted",
    error_deleting_course: "Error deleting course",

    course_create_edit_title:"Information",
    course_create_new:"New course",
    nav_create_course: "New course",
    course_create_edit_name:"Name",
    course_create_edit_short_name:"Short name",
    course_create_edit_teachers_all:"All teachers",
    course_create_edit_teachers:"Teachers",
    course_create_edit_add_teachers:"Add teachers",
    course_create_edit_code:"Access code",
    course_create_edit_public:"Public course",
    course_create_edit_no_users:"No users",

    course_edit_notification_title: "Course edited",
    course_edit_notification_text: "Changes made to the course have been saved.",
    course_create_notification_title: "Course created",
    course_create_notification_text: "Course has been created successfully.",

    // LessonUserList
    lesson_user_list_title: "Student list",
    lesson_user_list_header_user: "User",
    lesson_user_list_header_solution: "Module solutions",
    lesson_user_list_header_detail: "Detail",
    lesson_user_list_filter_completed: "Show successful solutions",
    lesson_user_list_filter_requests: "Show requests",
    lesson_user_list_filter_allowed_show: "Show only published solutions",
    lesson_user_list_row_detail: "User solutions",

    // LessonUserListLeftDrawer
    lesson_user_list_left_drawer_users: "Solution list",
    lesson_user_list_left_drawer_module: "Module detail",
    lesson_user_list_empty: "No users satisfy the filter",
    lesson_user_list_previous: "Previous",
    lesson_user_list_next: "Next",
    lesson_user_list_rule: "Scoring Rules",

    // LessonSolutions
    lesson_solutions_users: "Students",
    lesson_solutions_modules: "Modules",
    lesson_solutions_to_lesson: "Back to lesson",
    lesson_solutions_course_users: "Course users",
    lesson_solutions_note_visible_lesson: "Note: Only students who can view this lesson are listed.",
    lesson_solutions_delete_dialog_start_answer: "Are you sure you want to delete this answer?",
    lesson_solutions_delete_dialog_start_comment: "Are you sure you want to delete this comment?",

    // NotificationMenu
    notification_menu_title: "Notifications",
    notification_show_satisfied: "Satisfied only",
    notification_list_empty: "✨ You have no unread notifications",
    notification_list_all_empty: "✨ You have no notifications",
    notification_list_mark_satisfied: "Mark all as satisfied",
    notification_list_show_all: "All notifications",

    notification_help: "😸 {0} answered to your help request of task <strong>{1}</strong>: {2}",
    notification_comment: "💬 {0} commented your solution of task <strong>{1}</strong>: {2}",
    notification_evaluate: "⬇️ {0} evaluated your solution of task <strong>{1}</strong>: {2}",
    notification_help_teacher: "😿 {0} asked for help with task <strong>{1}</strong>: {2}",
    notification_evaluate_teacher: "⬆️ {0} asked for evaluation of task <strong>{1}</strong>: {2}",
    notification_comment_teacher: "💬 You commented to student {0} his solution of task <strong>{1}</strong>: {2}",

    // AppFooter
    trainer_footer_title: "Trainer – education support",
    trainer_footer_report: "Report problem",
    trainer_version: "Version",

    // Nav
    nav_users: "Users",
    nav_import_users: "Import users",
    nav_create_lesson: "New lesson",
    nav_edit_lesson: "Edit lesson",
    nav_lesson_solutions: "Solutions",
    nav_lesson_user_list: "Users",
    nav_create_module: "New module",
    nav_notification_list: "All notifications",

    // Separate pages
    presentation_page_title: "Presentation",
    info_page_title: "Information",
    guide_page_title: "Guide",
    guide_teachers: "Guide for teachers",
    guide_students: "Guide for students",
    guide_guarantors: "Guíde for guarantors",
    guide_admins: "Guide for administrators",

    // LoginForm
    login: "Log in",
    login_ctu: "Log in with CTU account",
    presentation_link: "Presentation",
    show_info: "About application",

    // Requests
    pending_request_eval: "Evaluation request",
    pending_request_help: "Help request",
    pending_request_eval_teacher: "Unanswered evaluation request: {0}",
    pending_request_help_teacher: "Unanswered help request: {0}",

    right_drawer_requests: "Requests",
    right_drawer_compilation: "Compilation and tests",

    request_none: "No requests.",
    request_eval_btn: "Submit",
    request_eval_cancel_btn: "Cancel submission",
    request_help_btn: "Request help",
    request_help_cancel_btn: "Cancel request",
    request_load_fail: "Error loading student request",
    request_load_text_fail: "An error occurred while loading the last student request: {0}",
    request_no_text: "<no text>",
    request_teacher_eval_btn: "Evaluate",
    request_teacher_comment_btn: "Comment",
    request_teacher_help_btn: "Answer",
    request_teacher_answered: "{0} answered",
    request_teacher_commented: "{0} commented",
    request_answer_delete_btn: "Delete answer",
    request_comment_delete_btn: "Delete comment",
    request_answer_deleted_title: "Answer deleted",
    request_answer_deleted_title_fail: "Error deleting answer",
    request_answer_deleted_text: "The answer has been deleted.",
    request_answer_deleted_text_fail: "An error occurred while deleting the answer: {0}",

    edit_code_from_gitlab: "Import from Gitlab",
    gitlab_dialog_title: "Import from Gitlab",
    gitlab_import_list_header_name: "Project Name",
    import_gitlab_list_list_header_type: "Owned project",
    import_gitlab_list_list_header_type_true: "Only owned",
    import_gitlab_list_list_header_type_false: "All projects",
    import_gitlab_list_list_header_search: "Search",
    gitlab_import_list_URI: "Link to the project on GitLab",
    gitlab_import_list_URI_btn: "Go",
    gitlab_import_list_header_description: "Description",
    gitlab_import_list_header_check_files: "Check Files to Import",
    gitlab_import_list_header_check_files_folder: "Files in folder",
    gitlab_return_back_folder: "Previous folder",
    gitlab_import_page_back: "Previous page",
    gitlab_back: "Back",
    gitlab_import_page_front: "Next page",

    gitlab_import_file_list_header_name: "File name",
    gitlab_import_file_list_header_path: "File path",
    gitlab_import_file_list_header_add_file_as: "Action",

    import_gitlab_file_list_type_description: "Module assignment",
    import_gitlab_file_list_type_default_code: "Code",
    import_gitlab_file_list_type_test_code: "Test code",
    import_gitlab_file_list_add_to_module: "Add to module",

    //Logs
    log_button: "Logs",
    log_list: "Log list",
    log_delete: "Delete logs",
    log_delete_older_than: "Delete logs older than",
    log_date_required: "Date is required",
    log_delete_title: "Log deletion",
    log_delete_success_text: "Logs were deleted",

  // Import parallels
    view_students: "View Students",
    import_students: "Import students from CSV",
    select_student_csv: "Select Student CSV",
    upload_and_preview: "Upload and Preview",
    select_parallels_to_create: "Select parallels you want to create",
    select_all: "Select All",
    parallel: "Parallel",
    student_count: "Students",
    actions: "Actions",
    create_selected_parallels: "Create selected parallels",
    selected: "Selected",
    start_over: "Start Over",
    first_name: "First Name",
    last_name: "Last Name",
    username: "Username",
    ungrouped: "Ungrouped",
    csv_only_error: "Only .csv files are supported.",
    csv_empty_error: "CSV is empty or invalid.",
    csv_no_students_error: "No valid students found in CSV.",
    csv_parse_failed: "Failed to read file",
    csv_course_create_notification_title: "Courses created",
    csv_course_create_notification_text: "Selected parallels were successfully created",
    failed_for: "failed for",
    btn_subject_create_new: "Create new subject",
    missing_semester_or_subject: "Missing semester or subject id",
    set_ids: "Set IDs",
    semester_id: "Semester ID",
    subject_id: "Subject ID",
    import_id_cancel: "Cancel",
    import_id_save: "Save",

    request_help: {
        title: "Request sent",
        title_fail: "Error sending request",
        text: "The help request was successfully sent.",
        text_fail: "An error occurred while attempting to send a help request: {0}",

        dialog_title: "Help request",
        textarea: "Request text",
        action: "Send",

        cancel_title: "Request canceled",
        cancel_title_fail: "Error canceling request",
        cancel_text: "The help request was successfully canceled.",
        cancel_text_fail: "An error occurred while canceling the help request: {0}",
        cancel_text_fail_satisfied: "The help request was already satisfied.",
    },
    request_teacher_help: {
        title: "Request resolved",
        title_fail: "Error submitting request",
        text: "Help request has been resolved successfully.",
        text_fail: "An error occured while attempting to resolve the help request: {0}",

        dialog_title: "Resolve help request",
        textarea: "Answer",
        action: "Answer",
    },
    request_eval: {
        title: "Assignment submitted",
        title_fail: "Error submitting assignment",
        text: "The assignment was successfully submitted for evaluation by the teacher.",
        text_fail: "An error occurred while attempting to submit the assignment: {0}",

        dialog_title: "Submit assignment",
        textarea: "Comment",
        action: "Submit",

        cancel_title: "Request canceled",
        cancel_title_fail: "Error canceling request",
        cancel_text: "The request for evaluation was successfully canceled.",
        cancel_text_fail: "An error occurred while canceling the request for evaluation: {0}",
        cancel_text_fail_satisfied: "The request for evaluation was already satisfied.",
    },
    request_teacher_eval: {
        title: "Assignment evaluated",
        title_fail: "Error whilst evaluating",
        text: "Assignment has been successfully evaluated.",
        text_fail: "An error occurred whilst trying to evaluate assignment: {0}",

        dialog_title: "Evaluate Assignment",
        textarea: "Evaluation",
        percent: "Evaluate:",
        action: "Evaluate",
        toggle: "Mark assignment as completed",
    },
    request_teacher_comment: {
        title: "Assignment commented",
        title_fail: "Error whilst sending comment",
        text: "Assignment has been successfully commented.",
        text_fail: "An error occurred whilst trying to comment assignment: {0}",

        dialog_title: "Comment Assignment",
        textarea: "Comment",
        percent: "Evaluate: {0} %",
        action: "Comment",
        toggle: "Mark assignment as completed",
    },

    // CodeModuleBottomOverlay
    code_module: {
        allowed_show: {
            title: "Successful publication",
            title_fail: "Publication unsuccessful",
            text: "Anonymous code publication was successful.",
            text_fail: "An error occurred during anonymous code publication: {0}",
        },
        disallowed_show: {
            title: "Unpublication successful",
            title_fail: "Unpublication unsuccessful",
            text: "Anonymous unpublication of code was successful.",
            text_fail: "An error occurred during the unpublication of anonymous code: {0}",
        },
        allow_show_tooltip: "Allow anonymous publication",
        disallow_show_tooltip: "Cancel anonymous publication",
        file_upload: "Code (.c, .cpp, .cxx)",
        code_inserted_title: "Code insertion successful",
        code_inserted_text: "The code was successfully inserted, testing is in progress...",
        code_inserted_failure_title: "Code insertion failed",
        code_inserted_failure_text: "System wasn't able to determine, which file you are trying to upload.\nUploaded file's name must end the same as a file name in editor\n(e.g. student.cpp -> whateverxyz-student.cpp)",
        download: "Download",
        default_code: "Default code",
        submitted_code: "Submitted code",
        reference_solution: "Reference solution",
        test_data: "Test data",
        reset_progress: "Reset progress",
        reset_progress_dialog_text: "Are you sure you want to reset your progress for this module?",
        test_name_tooltip: "Test set name",
        tests_passed_total_tooltip: "Number of tests passed in the set",
        tests_show_outputs: "Show outputs",
        tests_show_error: "Show error",
        tests_description: "Description:",
        terminate: "Terminate",
        run_tests: "Run tests",
        run_showcase: "Run showcase",
        tab_input: "Input",
        tab_comparison: "Comparison",
        tab_compilation: "Compilation error",
        tab_student: "Student",
        tab_reference: "Reference",
        test_compilation: "Compilation",
        test_compilation_info: "Compiles and links code.",
        character_limit: "{0} / {1} characters",
        edit_module: "Edit module",
        module_solutions: "Show module solutions",
        tab_teacher: "TESTER",
        code_comment: "Comment",
        create_code_comment: "Write a comment",

    error_compiling: "Compilation error",
    error_code_too_large: "The code is too long ({0} / {1} characters)",
    error_linking: "Linking error",
    error_output: "Output",
    error_ret_code_not_ok: "Program ended with a non-zero return code {0}",
    error_should_fail_didnt_fail: "The program was faulty, but the student's asserts did not reveal the error.",
    error_shouldnt_fail_did_fail: "The program was correct, but one of the student's asserts failed.",
    error_invalid_output: "Invalid output",
    error_missing_output_image: "Student's image was not found",
    error_memory_not_freed: "The program only freed {0} / {1} dynamically allocated memory blocks.",
    error_exception_limit_exceeded: "The program exceeded the exceptions limit. It used {0} exceptions, the limit was {1}.",
    error_program_timeout: "The program exceeded the time limit, {0}.",

        edit_tab_information: "Code module",
        edit_tab_information_tests_success_title: "Success",
        edit_tab_information_tests_success_body: "Tests imported successfully",
        edit_tab_tests: "Tests",
        edit_tab_student: "Default code",
        edit_tab_envelope: "Code envelope",
        edit_tab_teacher: "Test code",

        edit_code_type: "Code type",
        type_showcase: "Showcase",
        type_test_io: "Standard I/O test",
        type_test_assert: "Assert test",
        type_write_assert: "Write asserts",

        edit_interaction: "Interaction",
        interaction_editor: "Code editing and uploading",
        interaction_updown: "Code uploading only",

        code_limit_small: "Small (1 kB)",
        code_limit_medium: "Medium (5 kB)",
        code_limit_large: "Large (10 kB)",

        edit_file_limit: "Limit for uploaded file size",
        file_limit_small: "Small (10 kB)",
        file_limit_medium: "Medium (40 kB)",
        file_limit_large: "Large (80 kB)",

        edit_envelope_type: "Code envelope",
        env_type_c: "C code (no I/O)",
        env_type_c_io: "C code, redirected I/O",
        env_type_cpp: "C++ code (no STL)",
        env_type_cpp_stl: "C++ code (with STL)",
        env_type_custom: "Custom envelope",

        edit_library: "Library",
        library_type_none: "None",
        library_type_c: "C library",
        library_type_cpp: "C++ library",

    edit_reference_public: "Reference solution is downloadable",
    edit_external_library: "Library for linking",

    edit_hide_compiler_output:
        "Hide compiler output, only show student whether or not compilation was successful.",

        file_label_showcase: "Sample inputs (.in) in .tar archive",
        file_label_test_io: "Test inputs (.in, .ref) in .tar archive",

        edit_test_name: "Test name",
        edit_test_description: "Test description",
        edit_test_parameter: "Parameter (positive whole number)",
        edit_test_parameter_tooltip: "One test corresponds to one execution of the test code, with this number as a command line argument.",
        edit_test_time_limit: "Time limit in whole seconds (empty = no limit)",
        edit_test_exception_limit: "Exception usage limit (whole number) (empty = no limit)",
        edit_test_check_memory: "Check memory access",
        edit_test_hidden: "Hide test outputs",
        edit_test_should_fail: "Test should fail",
        delete_test: "Delete test",
        delete_test_dialog_start: "Are you sure you want to delete test ",
        delete_test_dialog_middle: "?",
        create_test: "Add test",
        delete_test_title: "Test deleted",
        delete_test_text: "Test has been deleted successfully.",
        new_test: "New test",
        create_test_requirements: "The new test must contain non-empty name, description and parameter",

        edit_file_name: "File name",
        edit_file_code_limit: "Limit for uploaded code size",
        edit_file_content: "Default file content",
        edit_file_header_file: "Header file (do not compile)",
        edit_file_reference: "Reference solution",
        delete_file: "Delete file",
        delete_file_dialog_start: "Are you sure you want to delete file ",
        delete_file_dialog_middle: "?",
        create_file: "Create file",
        delete_file_title: "File deleted",
        delete_file_text: "File has been successfully deleted.",
        new_file: "New file",
        create_file_requirements: "The new file must contain non-empty name and content",

        // Automatic generation
        generate_dialog_title: "Generate settings",
        generate_dialog_text_p1: "Would you like to use the default settings (tests, files, envelope and tester code) for this type of code module?",
        generate_dialog_text_p2: "Warning: Irreversibly clears all current settings.",
        generate_dialog_no: "No",
        generate_dialog_yes: "Yes",

        basic_test_name: "Basic test",
        basic_test_description: "Tests basic functionality",
        random_test_name: "Random test",
        random_test_description: "Tests the program with random values",
        efficiency_test_name: "Efficiency test",
        efficiency_test_description: "Tests the program's efficiency",
        correct_implementation_test_name: "Correct implementation",
        correct_implementation_test_description: "All asserts pass for a correct implementation",
        wrong_implementation_test_name: "Incorrect implementation",
        wrong_implementation_test_description: "The asserts catch an incorrect implementation",
    },

    // AssignmentModule
    assignment_module: {
        error_file_too_large: "File is too large (max. size is 1 MB)",
        input_label: "Image (.jpg, .jpeg, .png)",
    },

    //QuizModule
    quiz_module: {
        create_new_quiz_tab: "Quiz editor",
        question_list: "List of questions",
        add_existing_question: "Add existing question",
        create_new_question : "create new question",
        create_new_quiz_heading: "Your quiz",
        question: "Question",
        new_question_dialog_heading: "New Question",
        edit_question_dialog_heading: "Edit Question",
        chosen_question_type: "Chosen question type",
        tooltip_truefalse: "Enter a question or statement and select if its true or not",
        tooltip_multichoice: "Enter a question and number of options for students to choose from",
        option: "Option",
        correct_option: "Correct?",
        add_option: "Add option",
        time_limit: "Time limit (seconds)",
        explanation: "Explanation",

        question_list_add_title: "Add question",
        question_list_header_id: "Identifier",
        question_list_header_text: "Question text",
        question_list_header_author: "Author",
        question_list_header_type: "Type",
        question_list_header_topics: "Topics",
        question_list_header_subjects: "Subjects",
        question_list_header_topics_selected: "{0} selected",
        question_list_header_subjects_selected: "{0} selected",
        question_list_header_action: "Action",
        question_list_empty: "No questions to add",
        question_list_search_empty: "No questions correspond to your search",
        question_list_topics_empty: "No topics",
        question_list_subjects_empty: "No subjects",
        question_list_clear_filters: "Clear filters",

        question_list_delete_question_title: "Delete question",
        question_list_delete_question_text_p1: "Are you sure you want to delete question ",
        question_list_delete_question_text_p2: "?",
        question_list_cannot_delete: "Only the author of a question may delete it",
        question_list_cannot_add: "This question is already a part of this quiz",

        remove_question: "Remove question",
        remove_question_dialog_start: "Are you sure you want to remove this question from the quiz?",
        remove_question_dialog_end: `You may add it back at any time in the "Add existing question" menu.`,

        create_question: "create question",
        edit_question: "edit question",
        quiz : "Quiz",
        no_questions_dialog_heading: "This quiz doesn't contain any questions",
        no_questions_dialog_text: "Please add at least one question before running the quiz",
        create_room: "Create quizroom",
        enter_room: "Enter",
        wrong_code_dialog: "Wrong code",
        wrong_code_dialog_text: "Check the the passcode and try again. In case that no code seems to be working, check if you are in trying to join the correct quiz if you have more of them in this lesson.",
        enter_code_placeholder: "Enter password here - (teacher is probably projecting it)",

        waiting_room: "Waiting room",
        waiting_room_joke: "Quickly run through everything you should have learned for today",
        room_password: "Password",
        number_of_students: "Number of students: ",
        students: "Students",
        launch_quiz: "Launch quiz",

        next_question: "Next question",
        end_quiz: "End quiz",

        results: "Results",
        review: "Review",
        leave: "Leave",

        points: "Points",
        student_passed: "Passed",
        student_didnt_pass: "Didn't pass",

        fix_eval: "Fix evaluation",
        reasign_points: "Reassign points",
        go_back: "Go back",
        question_edited_allert_heading: "Question edited",
        question_edited_allert_text: "Point assignment was changed. Affected students:",
        room_id: "Room ID"

    },

    //SelftesModule
    selftest_module: {
        create_new_selftest_tab: "Selftest editor",
        selftest_heading_info: "Here you can insert from which students can generate practice tests.",
        selftest: "Selftest",
        number_of_questions: "Number of questions",
        too_many_questions: "Too many questions",
        invalid_number_of_questions: "Invalid number of questions",
        time_difficulty: "Time difficulty",
        launch: "Launch",
        to_review: "To review",
        leave: "Leave",
        question: "Question",
        question_status_positive: "Filled in",
        question_status_negative: "Not filled in",
        to_question: "To question",
        hand_in: "Submit",
        correctly_answered: "Correctly answered",
        success_rate: "Success rate",
        to_start: "Back to main screen",

        attempt: "Attempt",
        quizroom: "Room",

    },

  //Template
  template_title: "Templates",
  template_module_test_title: "Use template",
  template_module_test_button: "Copy tests from another module",
  template_create_button: "Create template",
  template_use_button: "Use template",
  template_create_notification_title: "Template Created",
  template_create_notification_text: "Your template has been successfully created.",
  template_update_notification_title: "Template Updated",
  template_update_notification_text: "Your template has been successfully updated.",
  template_list_delete_template_title: "Delete template",
  template_list_delete_template_text_p1: "Are you sure you want to delete template ",

  //Dev version notofication
  dev_version_notofication: "Warning! This is DEV version of application.",

  //Impersonation
  impersonation_mode: "You are in impersonation mode",
  impersonation_mode_off: "End impersonation mode",
  impersonation_mode_out: "Impersonation ended",
  impersonation_activated_title: "Impersonation activated",
  impersonation_activated_text_prefix: "You are now viewing as",
  impersonation_error_title: "Impersonation error",
  impersonation_error_fallback: "Impersonation failed.",
  error_creating_user: "Error while creating a test user",
  error_deleting_user: "Error while deleting a test user",
  create_test_user_title: "Choose it's name",
  name_placeholder: "Franta Soup",
  test_users_list_title: "List of test users",
  create_test_user_btn: "Create a test user",
  connect_btn: "connect",
  confirm_delete_test_user: "Do you really wish to delete this test user",
  no_test_users_found: "No test users were found.",
  //Custom compiler flags
  custom_compiler_flag_title: "Custom compiler flags",
  custom_compiler_flag_close: "Close",
  custom_compiler_flag_name: "Name(optional)",
  custom_compiler_flag_flags: "Flags",
  custom_compiler_flag_action: "Action",
  custom_compiler_flag_name_placeholder: "Enter a name",
  custom_compiler_flag_flags_placeholder: "Enter a custom -D flags f.e. -DITER=1000 -DMAX_TIME=10",
  custom_compiler_flag_success: "SUCCESS",
  custom_compiler_flag_error: "ERROR",
  custom_compiler_flag_create_success: "Compiler flag added successfully",
  custom_compiler_flag_edit_success: "Compiler flag edited successfully",
  custom_compiler_flag_delete_success: "Compiler flag removed successfully",
  custom_compiler_flag_invalid_flag: "Invalid flag given",
  custom_compiler_flag_add_new_title: "Add new compiler flag",

  // Test groups
  test_group_title: "Test groups",
  test_group_name: "Group",
  test_group_unassigned_tests: "Unassigned tests",
  test_group_unassigned_tests_placeholder: "Drag tests from groups here to unassign them",
  test_group_placeholder: "Drop tests here",
  test_group_description_placeholder: "No compiler flag",
  test_group_test_move_success: "Test was moved successfully",
  test_group_test_assign_success: "Test assigned successfully",
  test_group_test_unassign_success: "Test unassigned successfully",
  test_group_delete_success: "Test group deleted successfully",
  test_group_no_groups_placeholder: "You have 0 test groups",
  test_group_edit_name_title: "Test group name",
  test_group_edit_flag_title: "Custom compiler flags",
  test_group_edit_create_button: "CREATE",
  test_group_edit_selection_name: "Name",
  test_group_edit_go_back: "Go back",
  test_group_edit_create_success: "Test group created successfully",
  test_group_edit_create_fail: "Test group creation failed",
  test_group_edit_success: "Test group edited successfully",
  test_group_edit_fail: "Test group edit failed",
  test_group_add_new_title: "Add new test group",
  test_group_notification_success: "SUCCESS",

}
